import * as React from 'react';
import Loader from 'react-loader';
import notify from '../../../../../shared/feedback/notifications';
import DateTime from 'react-datetime';
import { connect } from 'react-redux';
import {
    Button,
    FormControl,
    InputGroup,
    FormGroup,
    ControlLabel,
    HelpBlock,
    Row,
    Col,
    Modal,
    ButtonGroup,
    ButtonToolbar,
    Checkbox,
    Panel,
    MenuItem,
    DropdownButton
} from 'react-bootstrap';
import Moment from 'moment';
import FontFaceObserver from 'fontfaceobserver';
import { withRouter } from 'react-router-dom';
import * as Status from '../PlanOrderStatus';
import * as actions from '../actions/PlanOrderActions';
import { checkIfOrderIsArchived } from '../../../OrdersActions';
import * as PlanOrderStatus from '../PlanOrderStatus';
import { editOrderRow, updateOrderRow } from '../../basicorderinfo/Actions';
import * as Feature from '../../../../../shared/Features';
import { Translate } from '../../../../../shared/LanguageService';
import { assign } from '../../../../../shared/Assign';
import {
    AnnotationNormal,
    AnnotationTexts,
    AnnotationFloorCrop,
    ExternalAnnotation,
    DeliveryAnnotation,
    ExternalDeliveryAnnotation
} from '../../../../planannotation/AnnotationTypes';
import {
    IUpdateStorey,
    IUpdateSortModel,
    IAnnotationViewModel,
    IDelivery,
    ISendPlanOrderModel
} from '../Entities';
import {
    ISelectedImage,
    PlanOrderStoreyFileType,
    ISelect
} from '../../../../../components/common/planOrder/Entities';
import { handleError } from '../../../../../shared/ErrorCatching';
import { BrokerAgentWithDropDown, BrokerFirmWithDropDown } from '../../common/BrokerTreeElements';
import { PhotoOrPlan, IOrderRow as BasicOrderRow, OrderTypes } from '../../basicorderinfo/Types';
import {
    TransformCompareStoreys,
    ICompareImagesStorey
} from '../../../../../components/common/planOrder/comparing/CompareImages';
import CompareImageModal from '../../../../../components/common/planOrder/comparing/CompareImagesModal';
import FormSelect from '../../../../../components/common/FormSelect';
import FormValidationService from '../../../../../shared/form/FormValidationService';
import FormInputChangeHandler from '../../../../../shared/form/FormInputChangeHandler';
import TemplatesForm from '../../../../../components/common/planOrder/TemplatesForm';
import StoreySelect from '../../../../../components/common/planOrder/StoreySelect';
import StoreySort from '../../../../../components/common/planOrder/StoreySort';
import PlanAnnotationTool from '../../../../planannotation/PlanAnnotationTool';
import Dropzone from '../../../../../components/common/Dropzone';
import ImageModal from '../../../../../components/common/planOrder/ImageModal';
import FilePlacementsModal from '../../../../planannotation/FilePlacementsModal';
import CheckDelivery from '../../../../../components/common/planOrder/deliveryFiles/CheckDelivery';
import ExternalFilesForm from '../../../../../components/common/planOrder/externalFiles/ExternalFilesForm';
import StoreyExternalFilesModal from '../../../../../components/common/planOrder/externalFiles/StoreyExternalFilesModal';
import ConfirmationModal from '../../../../../components/common/ConfirmationModal';
import DateTimeView from '../../../../../features/localDate/DateTimeView';
import BasicOrderInfoApi from '../../basicorderinfo/BasicOrderInfoApi';
import OrderRowForm from '../../basicorderinfo/orderrow/OrderRowForm';
import ValidatableFormGroup from '../../../../../components/common/ValidatableFormGroup';
import * as OrderState from '../../basicorderinfo/OrderState';
import { IPlanOrder, IOrderRow, IExternalPlanOrderFile, IStatusModel } from './entities';
import OrderRowsForm from './OrderRowsForm';
import StoreyFile from './StoreyFile';
import BlueprintFile from './BlueprintFIle';
import StatusForm from './StatusForm';
import ReturnButton from './ReturnButton';
import ReturnedMessageText from './ReturnedMessageText';
import * as ArchiveStatus from '../../../../../shared/ArchiveStatus';
import { selectArchivedInfo } from '../../../../../store/selectors/OrderSelectors.store';
import * as CubiCasaOrderStatus from '../../../../../shared/CubiCasaOrderStatus';
import InternalNotes, { InternalNotesLabels } from './InternalNotes';
import ConnectCubiCasaModal from "./ConnectCubiCasaModal";

interface IActions {
    getPlan: (planOrderId: number) => Promise<any>;
    updatePlanFirm: (planOrderId: number, planFirmId: number) => Promise<any>;
    updatePlanEditor: (planOrderId: number, planEditorId: number) => Promise<any>;
    removeOrderRow: (planOrderId: number, orderRowId: number) => Promise<any>;
    addOrderRow: (planOrderId: number, productId: number) => Promise<any>;
    updateStorey: (
        planOrderId: number,
        planOrderStoreyId: number,
        data: IUpdateStorey
    ) => Promise<any>;
    updateSort: (planOrderId: number, storey: IUpdateSortModel) => Promise<any>;
    editExternalFileAnnotation: (fileId: number) => Promise<any>;
    editDeliveryFileAnnotation: (fileId: number) => Promise<any>;
    editAnnotation: (id: number, planAnnotationType: string) => Promise<any>;
    saveAnnotation: (
        planOrderStoreyFileId: number,
        data: string,
        hasDoneCrop: boolean,
        revisionType: number,
        annotationType: string
    ) => Promise<any>;
    deleteStorey: (planOrder: number, storeyId: number) => Promise<any>;
    sendPlanOrder: (planOrderId: number, planOrder: ISendPlanOrderModel) => Promise<any>;
    sendToPlanFirm: (planOrderId: number, data: any) => Promise<any>;
    addStorey: (storey: any) => Promise<any>;
    deliverPlanOrder: (planOrderId: number, data: IDelivery) => Promise<any>;
    returnPlanOrder: (planOrderId: number) => Promise<any>;
    returnSketchUpPlanOrder: (planOrderId: number) => Promise<any>;
    returnRoomSketcherPlanOrder: (planOrderId: number) => Promise<any>;
    downloadFiles: (planOrderId: number) => Promise<any>;
    updatePlacements: (
        planOrderId: number,
        files: any[],
        planOrderStoreyFileId: number
    ) => Promise<any>;
    generateFiles: (planOrderId: number) => Promise<any>;
    approvePlanOrder: (planOrderId: number) => Promise<any>;
    addPlanOrderStoreyBlueprintFile: (planOrderStoreyId: number, file: any) => Promise<any>;
    addPlanOrderStoreySketchUp2DFile: (planOrderStoreyId: number, file: any) => Promise<any>;
    addPlanOrderStoreySketchUp3DFile: (planOrderStoreyId: number, file: any) => Promise<any>;
    addPlanOrderStoreyRoomSketcher2DFile: (planOrderStoreyId: number, file: any) => Promise<any>;
    addPlanOrderStoreyRoomSketcher3DFile: (planOrderStoreyId: number, file: any) => Promise<any>;
    addPlanOrderInternalExternalFile: (
        id: number,
        planOrderId: number,
        fileInfoId: number,
        filename: string,
        fileReference: string,
        fileType: string,
        thumbnailReference: string,
        oldFileId: number
    ) => Promise<any>;
    addPlanOrderExternalDeliveryFile: (
        id: number,
        planOrderId: number,
        fileInfoId: number,
        filename: string,
        fileReference: string,
        fileType: string,
        thumbnailReference: string,
        oldFileId: number
    ) => Promise<any>;
    addPlanOrderStoreyExternalFile: (
        planOrderStoreyId: number,
        fileInfoId: number,
        filename: string,
        fileReference: string,
        fileType: string,
        thumbnailReference: string,
        oldFileInfoId: number,
        oldFileReference: string
    ) => Promise<any>;
    deletePlanOrderInternalExternalFile: (planOrderId: number, fileInfoId: number) => Promise<any>;
    deletePlanOrderExternalDeliveryFile: (planOrderId: number, fileInfoId: number) => Promise<any>;
    deletePlanOrderStoreyExternalFile: (
        planOrderId: number,
        planOrderStoreyId: number,
        fileInfoId: number
    ) => Promise<any>;
    createStorey: (planOrderId: number, data: any) => Promise<any>;
    updateStartDate: (planOrderId: number, date: any) => Promise<any>;
    toggleTemplateGeneration: (planOrderId: number) => Promise<any>;
    resetDelivery: (planOrderId: number) => Promise<any>;
    stopDelivery: (planOrderId: number) => Promise<any>;
    grabPlanOrder: (planOrderId: number) => Promise<any>;
    createEmptyStorey: (planOrderId: number) => Promise<any>;
    deleteDeliveryFile: (reference: string) => Promise<any>;
    hideDeliveryFailure: (
        planOrderId: number,
        sketchUpStatus: number,
        roomSketcherStatus: number
    ) => Promise<any>;
    emailFiles: (planOrderId: number) => Promise<any>;
    email: (planOrderId: number) => Promise<any>;
    returnToBroker: (planOrderId: number) => Promise<any>;
    setSketchupStatus: (planorderId: number, newStatus: number) => Promise<any>;
    setRoomsketcherStatus: (planorderId: number, newStatus: number) => Promise<any>;
    editOrderRow: (orderId: number, rowId: number) => Promise<any>;
    updateOrderRow: (orderId: number, orderRow: IOrderRow) => Promise<any>;
    inActivateExternalFile: (planOrderExternalFileId: number) => Promise<void>;
    resetScheduledDelivery: (planOrderId: number) => Promise<any>;
    getCompareData: (planOrderId: number) => Promise<any>;
    checkIfOrderIsArchived: (planOrderId: number) => Promise<any>;
    resetPlanOrderArchiveState: (planOrderId: number) => Promise<any>;
    returnCubiCasaOrder: (planOrderId: number) => Promise<any>;
    deleteCubiCasaOrder: (planOrderId: number) => Promise<any>;
    connectCubiCasaOrder: (planOrderId: number, cubiCasaOrderId: string) => Promise<any>;
    manualSyncCubiCasaOrder: (planOrderId: number,cubiCasaOrderId: string) => Promise<any>;

}

interface IProps {
    orderId: number;
    actions: IActions;
    planOrder: IPlanOrder;
    products: ISelect[];
    planUserFirms: ISelect[];
    planEditors: ISelectPlanEditor[];
    annotation: IAnnotationViewModel;
    user: any;
    isMeasured: boolean;
    compareStoreys: ICompareImagesStorey[];
    order: {
        orderRows: any[];
        possibleProductsForUpdate: any[];
        orderState: {
            displayName: string;
            value: number;
        };
    };
    history: {
        push: (path: string) => void;
    };
    archivedInfo: {
        photoIsArchived: boolean;
        photoIsPreArchived: boolean;
        planIsArchived: boolean;
        planIsPreArchived: boolean;
        archivedStatus: number;
    };
}

interface IState {
    errors: any;
    showAnnotationModal: boolean;
    upload: boolean;
    delivery: IDelivery;
    validDeliveryDate: boolean;
    showImageModal: boolean;
    selectedImage: ISelectedImage;
    deliveryFileWasSelected: boolean;
    selectedAnnotationType: string;
    showCompareModal: boolean;
    storiesForCompare: ICompareImagesStorey[];
    selectedStoreyIdForCompare: number;
    showFilePlacementsModal: boolean;
    isGenerating: boolean;
    isCheckTabDisabled: boolean;
    storiesUploads: {
        [id: number]: {
            blueprint: boolean;
            external: boolean;
            sketchUp2D: boolean;
            showSketchUp2D: boolean;
            sketchUp3D: boolean;
            showSketchUp3D: boolean;
            roomSketcher2D: boolean;
            showRoomSketcher2D: boolean;
            roomSketcher3D: boolean;
            showRoomSketcher3D: boolean;
        };
    };
    selectedPlanOrderInternalExternalFile: string;
    selectedPlanOrderExternalDeliveryFile: string;
    planOrderInternalExternalFilesUpload: boolean;
    planOrderExternalFilesUploadToCustomer: boolean;
    showStoreyExternalFilesModal: boolean;
    selectedExternalStoreyFile: string;
    selectedExternalStoreyIndex: number;
    placementModalPlanOrderStoreyFileId: number;
    startDate: any;
    isSending: boolean;
    showDeleteStoreyConfirmation: boolean;
    confirmationDoAction?: () => any;
    showResetDeliveryConfirmationModal: boolean;
    showStopDeliveryConfirmationModal: boolean;
    fontSizeRatioForTextEdit?: number | null;
    showEditOrderRowModal: boolean;
    showEditOrderRowConfirmModal: boolean;
    includeEditOrderRowFileRemovalWarning: boolean;
    orderRow: {
        id: number;
        productId: number;
        productName: string;
        productPriceBrokerFirm: number;
        productPricePropertyOwner: number;
        photographerCompensation: number;
        photographerCompensationSetManually: boolean;
        quantity: number;
        invoiceComment: string;
        photographerComment: string;
        productTypeId: number;
        manuallySetCompensationBackup: number;
        photoOrPlan: number | OrderTypes;
        invoiceStatus: { value: number; displayName: string };
        canChange: boolean;
        canRemove: boolean;
    };
    editOrderRowFormErrors: any;
    showConfirmUploadStoreyFileModal: boolean;
    uploadFileStoreyId: number;
    uploadStoreyFileProperty: string;
    selectedStoreyFileType: number;
    deliveryDateText: string;
    startDateText: string;
    showOrder: boolean;
    loading: boolean;
    showGetPlanOrderFilesButton: boolean;
    showConnectCubiCasaModal:boolean;
}

interface ISelectPlanEditor {
    id: number;
    name: string;
    planFirmId: number;
}

class AdminPlanOrderForm extends React.Component<IProps, IState> {
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: IProps, context: any) {
        super(props, context);

        this.state = {
            errors: {},
            showAnnotationModal: false,
            upload: false,
            delivery: {
                message: '',
                shouldAppendToEmail: false,
                deliveryDate: null,
                hasDate: false
            },
            validDeliveryDate: false,
            showImageModal: false,
            selectedImage: null,
            deliveryFileWasSelected: false,
            selectedAnnotationType: AnnotationNormal,
            showCompareModal: false,
            storiesForCompare: [],
            selectedStoreyIdForCompare: null,
            showFilePlacementsModal: false,
            isGenerating: false,
            isCheckTabDisabled: false,
            storiesUploads: {},
            selectedPlanOrderInternalExternalFile: '',
            selectedPlanOrderExternalDeliveryFile: '',
            planOrderInternalExternalFilesUpload: false,
            planOrderExternalFilesUploadToCustomer: false,
            showStoreyExternalFilesModal: false,
            selectedExternalStoreyFile: '',
            selectedExternalStoreyIndex: null,
            placementModalPlanOrderStoreyFileId: null,
            startDate: null,
            isSending: false,
            showDeleteStoreyConfirmation: false,
            showResetDeliveryConfirmationModal: false,
            showStopDeliveryConfirmationModal: false,
            showEditOrderRowModal: false,
            showEditOrderRowConfirmModal: false,
            includeEditOrderRowFileRemovalWarning: false,
            orderRow: {
                id: -1,
                productId: -1,
                productName: '',
                productPriceBrokerFirm: -1,
                productPricePropertyOwner: -1,
                photographerCompensation: -1,
                photographerCompensationSetManually: false,
                quantity: -1,
                invoiceComment: '',
                photographerComment: '',
                productTypeId: -1,
                manuallySetCompensationBackup: -1,
                photoOrPlan: PhotoOrPlan.None,
                invoiceStatus: { value: -1, displayName: '' },
                canChange: false,
                canRemove: false
            },
            editOrderRowFormErrors: {},
            showConfirmUploadStoreyFileModal: false,
            uploadFileStoreyId: null,
            uploadStoreyFileProperty: null,
            selectedStoreyFileType: 0,
            deliveryDateText: '',
            startDateText: '',
            showOrder: false,
            loading: false,
            showGetPlanOrderFilesButton: false,
            showConnectCubiCasaModal: false
        };

        this.canReturnToCubiCasa = this.canReturnToCubiCasa.bind(this);
        this.returnCubiCasaOrder = this.returnCubiCasaOrder.bind(this);
        this.deleteCubiCasaOrder = this.deleteCubiCasaOrder.bind(this);
        this.updatePlanFirm = this.updatePlanFirm.bind(this);
        this.updatePlanEditor = this.updatePlanEditor.bind(this);
        this.filterPlanEditorsByPlanFirm = this.filterPlanEditorsByPlanFirm.bind(this);
        this.removeOrderRow = this.removeOrderRow.bind(this);
        this.addOrderRow = this.addOrderRow.bind(this);
        this.saveAnnotation = this.saveAnnotation.bind(this);
        this.sendForCustomer = this.sendForCustomer.bind(this);
        this.sendToPlanFirm = this.sendToPlanFirm.bind(this);
        this.onUploadCompleted = this.onUploadCompleted.bind(this);
        this.uploadFiles = this.uploadFiles.bind(this);
        this.onFileUploadCompleted = this.onFileUploadCompleted.bind(this);
        this.deliver = this.deliver.bind(this);
        this.onStartDateChanged = this.onStartDateChanged.bind(this);
        this.onDateTimeChange = this.onDateTimeChange.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.onHasDateChanged = this.onHasDateChanged.bind(this);
        this.onSelectImage = this.onSelectImage.bind(this);
        this.return = this.return.bind(this);
        this.returnSketchUp = this.returnSketchUp.bind(this);
        this.returnRoomSketcher = this.returnRoomSketcher.bind(this);
        this.downloadFiles = this.downloadFiles.bind(this);
        this.savePlacements = this.savePlacements.bind(this);
        this.approvePlanOrder = this.approvePlanOrder.bind(this);
        this.generateFiles = this.generateFiles.bind(this);
        this.uploadPlanOrderExternalFiles = this.uploadPlanOrderExternalFiles.bind(this);
        this.uploadPlanOrderExternalFilesToCustomer =
            this.uploadPlanOrderExternalFilesToCustomer.bind(this);
        this.onPlanOrderExternalFilesUploadCompleted =
            this.onPlanOrderExternalFilesUploadCompleted.bind(this);
        this.onPlanOrderInternalExternalFileUploadCompleted =
            this.onPlanOrderInternalExternalFileUploadCompleted.bind(this);
        this.onPlanOrderExternalDeliveryFileUploadCompleted =
            this.onPlanOrderExternalDeliveryFileUploadCompleted.bind(this);
        this.onStoreyExternalFilesUploadCompleted =
            this.onStoreyExternalFilesUploadCompleted.bind(this);
        this.onStoreyExternalFileUploadCompleted =
            this.onStoreyExternalFileUploadCompleted.bind(this);
        this.deletePlanOrderStoreyExternalFile = this.deletePlanOrderStoreyExternalFile.bind(this);
        this.toggleTemplateGeneration = this.toggleTemplateGeneration.bind(this);
        this.canAnnotatePlacement = this.canAnnotatePlacement.bind(this);
        this.isRoomSketcherOnly = this.isRoomSketcherOnly.bind(this);
        this.canResetDelivery = this.canResetDelivery.bind(this);
        this.canStopDelivery = this.canStopDelivery.bind(this);
        this.resetDelivery = this.resetDelivery.bind(this);
        this.stopDelivery = this.stopDelivery.bind(this);
        this.loadData = this.loadData.bind(this);
        this.canApprove = this.canApprove.bind(this);
        this.canGenerate = this.canGenerate.bind(this);
        this.showSaveStartDateButtons = this.showSaveStartDateButtons.bind(this);
        this.canGrabPlanOrder = this.canGrabPlanOrder.bind(this);
        this.grabPlanOrder = this.grabPlanOrder.bind(this);
        this.isFileLocked = this.isFileLocked.bind(this);
        this.createEmptyStorey = this.createEmptyStorey.bind(this);
        this.showAnnotationModal = this.showAnnotationModal.bind(this);
        this.deleteDeliveryFile = this.deleteDeliveryFile.bind(this);
        this.hideDeliveryFailure = this.hideDeliveryFailure.bind(this);
        this.canReturnToPlan = this.canReturnToPlan.bind(this);
        this.is = this.is.bind(this);
        this.isDelivered = this.isDelivered.bind(this);
        this.email = this.email.bind(this);
        this.emailFiles = this.emailFiles.bind(this);
        this.returnToBroker = this.returnToBroker.bind(this);
        this.roomsketcherStatusIs = this.roomsketcherStatusIs.bind(this);
        this.roomsketcherStatusIsAny = this.roomsketcherStatusIsAny.bind(this);
        this.sketchupStatusIs = this.sketchupStatusIs.bind(this);
        this.sketchupStatusIsAny = this.sketchupStatusIsAny.bind(this);
        this.openEditOrderRowModal = this.openEditOrderRowModal.bind(this);
        this.openEditOrderRow = this.openEditOrderRow.bind(this);
        this.onOrderRowChange = this.onOrderRowChange.bind(this);
        this.onPhotographerCompensationSetManuallyChange =
            this.onPhotographerCompensationSetManuallyChange.bind(this);
        this.orderRowProductSelected = this.orderRowProductSelected.bind(this);
        this.annotateExternalFile = this.annotateExternalFile.bind(this);
        this.annotateExternalDeliveryFile = this.annotateExternalDeliveryFile.bind(this);
        this.annotateDeliveryFile = this.annotateDeliveryFile.bind(this);
        this.showExternalFileAnnotationModal = this.showExternalFileAnnotationModal.bind(this);
        this.inActivateExternalFile = this.inActivateExternalFile.bind(this);
        this.onCompareFilterChanged = this.onCompareFilterChanged.bind(this);
        this.isApproved = this.isApproved.bind(this);
        this.resetScheduledDelivery = this.resetScheduledDelivery.bind(this);
        this.showPlanOrder = this.showPlanOrder.bind(this);
        this.resetPlanOrderArchiveState = this.resetPlanOrderArchiveState.bind(this);
        this.showConnectCubiCasaModal = this.showConnectCubiCasaModal.bind(this);
        this.closeConnectCubiCasatModal = this.closeConnectCubiCasatModal.bind(this);
        this.formInputChangeHandler = new FormInputChangeHandler(
            this.state.delivery,
            (delivery: IDelivery) => this.setState({ delivery: delivery } as IState)
        );
    }

    componentDidMount(): void {
        this.props.actions
            .checkIfOrderIsArchived(this.props.orderId)
            .then(() => {
                if (
                    (!this.props.archivedInfo.planIsArchived &&
                        !this.props.archivedInfo.planIsPreArchived) ||
                    this.props.archivedInfo.archivedStatus < ArchiveStatus.ArchivedCold
                ) {
                    this.loadData(this.props.orderId);
                }

                if (
                    this.props.archivedInfo.planIsPreArchived &&
                    this.props.archivedInfo.archivedStatus < ArchiveStatus.ArchivedGlacier
                ) {
                    this.setState({ showGetPlanOrderFilesButton: true });
                }
            })
            .catch((error: any) => handleError(error));
    }

    showPlanOrder() {
        this.loadData(this.props.orderId);
    }

    resetPlanOrderArchiveState() {
        this.setState({
            loading: true
        });

        this.props.actions
            .resetPlanOrderArchiveState(this.props.orderId)
            .then(() => {
                this.setState({
                    loading: false
                });
                this.loadData(this.props.orderId);
            })
            .catch(() => {
                this.setState({ loading: false });
                notify.failure(Translate('order/plan/error/reset-planorder'));
            });
    }

    loadData(orderId): void {
        this.setState({
            showOrder: true,
            loading: true
        });

        this.props.actions
            .getPlan(orderId)
            .then(() => {
                this.setState({ loading: false });
                this.disableCheckTab();
                this.forceUpdate();
            })
            .catch(() => {
                this.setState({ loading: false });
                notify.failure(Translate('order/plan/error/planorder'));
            });
    }

    UNSAFE_componentWillReceiveProps(nextProps: IProps): void {
        if (nextProps && nextProps.orderId !== this.props.orderId) {
            this.loadData(nextProps.orderId);
        } else if (nextProps.planOrder) {
            if (nextProps.planOrder.annotationTextInfo) {
                new FontFaceObserver(nextProps.planOrder.annotationTextInfo.font).load();
            }

            let delivery: IDelivery = {
                message: nextProps.planOrder.deliveryMessage,
                shouldAppendToEmail: nextProps.planOrder.deliveryShouldAppendToEmail,
                deliveryDate: nextProps.planOrder.deliveryDate
                    ? new Date(nextProps.planOrder.deliveryDate)
                    : null,
                hasDate: nextProps.planOrder.deliveryDate ? true : false
            };

            this.disableCheckTab(nextProps.planOrder);
            this.formInputChangeHandler.updateObj(delivery);
            this.setState({
                delivery: delivery,
                startDate: nextProps.planOrder.startDate
                    ? Moment(nextProps.planOrder.startDate.localDateTime)
                    : null,
                startDateText: nextProps.planOrder.startDate
                    ? Moment(nextProps.planOrder.startDate.localDateTime)
                          .format('YYYY-MM-DD HH:mm')
                          .toString()
                    : null
            } as IState);
        }
    }

    onStartDateChanged(moment: any): void {
        let date = Moment(moment, 'YYYY-MM-DD HH:mm', true);

        if (date.isValid()) {
            this.setState({
                startDate: date.toDate(),
                startDateText: date.format('YYYY-MM-DD HH:mm').toString()
            } as IState);
        } else {
            if (moment.length > 16) {
                return;
            }
            moment = this.formatDateText(moment, this.state.startDateText);
            this.setState({ startDateText: moment } as IState);
        }
    }

    updateStartDate(): void {
        this.props.actions
            .updateStartDate(this.props.planOrder.id, this.state.startDate)
            .then(() => {
                notify.success(Translate('order/plan/update-startdate/success'));
            })
            .catch(() => {
                notify.failure(Translate('order/plan/update-startdate/failure'));
            });
    }

    onDateTimeChange(moment: any): void {
        let date = Moment(moment, 'YYYY-MM-DD HH:mm', true);
        let delivery = { ...this.state.delivery };
        this.formInputChangeHandler.updateObj(delivery);

        if (date.isValid() && Moment().startOf('minute').isSameOrBefore(date)) {
            delivery.deliveryDate = date.toDate();
            this.setState({
                delivery: delivery,
                validDeliveryDate: true,
                deliveryDateText: date.format('YYYY-MM-DD HH:mm').toString()
            } as IState);
        } else if (date.isValid()) {
            delivery.deliveryDate = date.toDate();
            this.setState({
                delivery,
                validDeliveryDate: false,
                deliveryDateText: date.format('YYYY-MM-DD HH:mm')
            } as IState);
        } else {
            if (moment.length > 16) {
                return;
            }
            moment = this.formatDateText(moment, this.state.deliveryDateText);

            this.setState({
                validDeliveryDate: false,
                deliveryDateText: moment
            } as IState);
        }
    }

    formatDateText(moment: any, oldDateText: string): any {
        if (oldDateText.length < moment.length) {
            // Not deleting text
            switch (moment.length) {
                case 4:
                case 7:
                    moment = moment.concat('-');
                    break;
                case 10:
                    moment = moment.concat(' ');
                    break;
                case 13:
                    moment = moment.concat(':');
                    break;
            }
        } else if ('-: '.indexOf(oldDateText[oldDateText.length - 1]) > -1 && moment.length !== 0) {
            moment = oldDateText.slice(0, oldDateText.length - 2);
        }
        return moment;
    }

    onHasDateChanged(e: any): void {
        let delivery = this.state.delivery;

        delivery.hasDate = e.target.checked;

        delivery.deliveryDate = delivery.hasDate ? new Date() : null;
        let validDeliveryDate = delivery.hasDate ? true : false;

        this.formInputChangeHandler.updateObj(delivery);
        this.setState({
            delivery: delivery,
            validDeliveryDate: validDeliveryDate,
            deliveryDateText: Moment(delivery.deliveryDate).format('YYYY-MM-DD HH:mm').toString()
        } as IState);
    }

    onSelectImage(selectedImage: ISelectedImage, deliveryFileWasSelected: boolean): void {
        this.setState({
            showImageModal: true,
            selectedImage: selectedImage,
            deliveryFileWasSelected: deliveryFileWasSelected
        } as IState);
    }

    onCompareFilterChanged(showEverything: boolean) {
        this.onSelectCompareImage(
            this.state.selectedStoreyIdForCompare,
            this.state.selectedStoreyFileType,
            showEverything
        );
    }

    onSelectCompareImage(storeyId: number, storeyFileType: number, showEverything: boolean): void {
        this.props.actions.getCompareData(this.props.planOrder.id).then(() => {
            let storeys = TransformCompareStoreys(this.props.compareStoreys, showEverything);

            this.setState({
                showCompareModal: true,
                storiesForCompare: storeys,
                selectedStoreyIdForCompare: storeyId,
                selectedStoreyFileType: storeyFileType
            } as IState);
        });
    }

    isRoomSketcherOnly(): boolean {
        if (
            !this.props.planOrder ||
            !this.props.planOrder.sketchUpStatus ||
            !this.props.planOrder.roomSketcherStatus
        ) {
            return false;
        }

        return (
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.notOrdered &&
            this.props.planOrder.roomSketcherStatus.id !== PlanOrderStatus.notOrdered
        );
    }

    disableCheckTab(planOrder?: IPlanOrder): void {
        if (!planOrder) {
            planOrder = this.props.planOrder;
        }

        if (!planOrder.stories) {
            this.setState({ isCheckTabDisabled: false } as IState);
            return;
        }

        let disabled = planOrder.stories.some((x) => {
            if (planOrder.sketchUp2D && (!x.file2D || x.file2D.isAnnotation)) {
                return true;
            }

            if (planOrder.sketchUp3D && (!x.file3D || x.file3D.isAnnotation)) {
                return true;
            }
        });

        this.setState({ isCheckTabDisabled: disabled } as IState);
    }

    showSaveStartDateButtons(): boolean {
        if (!this.state.startDate || !this.props.planOrder.startDate) {
            return true;
        }

        let propsMoment = Moment(this.props.planOrder.startDate.localDateTime);
        let stateMoment = Moment(this.state.startDate);
        return !stateMoment.isSame(propsMoment);
    }

    setDeliveryDateFromNow(numberOfDays: number) {
        let delivery = { ...this.state.delivery };
        let newDate = Moment().add(numberOfDays, 'day').set({
            hour: delivery.deliveryDate.getHours(),
            minute: delivery.deliveryDate.getMinutes()
        });
        delivery.deliveryDate = newDate.toDate();
        this.setState({
            delivery: delivery,
            validDeliveryDate: true,
            deliveryDateText: newDate.format('YYYY-MM-DD HH:mm').toString()
        } as IState);
    }

    render() {
        const options = {
            position: 'relative',
            paddingTop: 20,
            paddingBottom: 30
        };

        if (!this.props.planOrder) {
            return <div></div>;
        }

        if (this.state.loading) {
            return (
                <div
                    className="progressbar-inline"
                    style={{
                        position: 'relative',
                        paddingBottom: 30
                    }}
                >
                    <Loader loaded={false} options={options} className="spinner"></Loader>
                </div>
            );
        }
        const { apiUrl } = window.appConfig;

        return (
            <div>
                <fieldset className="plan-order-head-info">
                    <legend>
                        {Translate('view-order/admin-planorder/order-info-status/title')}
                    </legend>
                    <Row>
                        <Col sm={4}>
                            {this.props.order.orderState.value === OrderState.Removed && (
                                <div className="alert alert-danger">
                                    {Translate('view-order/admin-planorder/warning/order-removed')}{' '}
                                    <i className="material-icons pull-right">warning</i>
                                </div>
                            )}
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('view-order/admin-planorder/order-info')}
                                </ControlLabel>
                                <div className="form-control-static">
                                    <Row>
                                        <Col sm={12}>
                                            <BrokerFirmWithDropDown
                                                user={this.props.user}
                                                name={this.props.planOrder.customer.firmName}
                                                brokerTreeNodeId={
                                                    this.props.planOrder.customer
                                                        .firmBrokerTreeNodeId
                                                }
                                                navigateTo={this.props.history.push}
                                            />
                                        </Col>
                                        <Col sm={12}>
                                            <BrokerAgentWithDropDown
                                                id={this.props.planOrder.customer.agentId}
                                                user={this.props.user}
                                                name={this.props.planOrder.customer.agentName}
                                                brokerTreeNodeId={
                                                    this.props.planOrder.customer
                                                        .agentBrokerTreeNodeId
                                                }
                                                navigateTo={this.props.history.push}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('view-order/admin-planorder/order-object')}
                                </ControlLabel>
                                <FormControl.Static>
                                    {this.props.planOrder.object}
                                </FormControl.Static>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('view-order/admin-planorder/created-date')}
                                </ControlLabel>
                                <FormControl.Static>
                                    <DateTimeView
                                        dateTime={this.props.planOrder.createdDate}
                                        format="L LT"
                                    />
                                </FormControl.Static>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('view-order/admin-planorder/start-date')}
                                </ControlLabel>
                                {!this.canChangeStartDate() && (
                                    <FormControl.Static>
                                        <DateTimeView
                                            dateTime={this.props.planOrder.startDate}
                                            format="L LT"
                                        />
                                    </FormControl.Static>
                                )}
                                {this.canChangeStartDate() && (
                                    <div>
                                        <InputGroup className="input-full-width">
                                            <DateTime
                                                inputProps={{
                                                    value: this.state.startDateText
                                                }}
                                                locale={Moment.locale()}
                                                value={this.state.startDate}
                                                onChange={this.onStartDateChanged}
                                            />
                                            {this.showSaveStartDateButtons() && (
                                                <InputGroup.Button>
                                                    <Button
                                                        bsSize="sm"
                                                        bsStyle="success"
                                                        onClick={this.updateStartDate}
                                                    >
                                                        <i className="material-icons">done</i>
                                                    </Button>
                                                    <Button
                                                        bsSize="sm"
                                                        bsStyle="danger"
                                                        onClick={() =>
                                                            this.setState({
                                                                startDate: Moment(
                                                                    this.props.planOrder.startDate
                                                                        .localDateTime
                                                                )
                                                            } as IState)
                                                        }
                                                    >
                                                        <i className="material-icons">clear</i>
                                                    </Button>
                                                </InputGroup.Button>
                                            )}
                                        </InputGroup>
                                    </div>
                                )}
                            </FormGroup>
                            {this.props.planOrder.customerReturnedDate && (
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate('view-order/admin-planorder/returned-date')}
                                    </ControlLabel>
                                    <FormControl.Static>
                                        <DateTimeView
                                            dateTime={this.props.planOrder.customerReturnedDate}
                                            format="L LT"
                                        />
                                    </FormControl.Static>
                                </FormGroup>
                            )}
                            {this.props.planOrder.roomSketcherLink && (
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate('view-order/admin-planorder/room-sketcher-link')}
                                    </ControlLabel>
                                    <FormControl.Static>
                                        <a
                                            target="_blank"
                                            href={this.props.planOrder.roomSketcherLink}
                                        >
                                            {this.props.planOrder.roomSketcherLink}
                                        </a>
                                    </FormControl.Static>
                                </FormGroup>
                            )}
                            {this.props.planOrder.roomSketcherFurnishLink && (
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'view-order/admin-planorder/room-sketcher-furnish-link'
                                        )}
                                    </ControlLabel>
                                    <FormControl.Static>
                                        <a
                                            target="_blank"
                                            href={this.props.planOrder.roomSketcherFurnishLink}
                                        >
                                            {this.props.planOrder.roomSketcherFurnishLink}
                                        </a>
                                    </FormControl.Static>
                                </FormGroup>
                            )}
                            {this.props.isMeasured ? (
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate('view-order/admin-planorder/cubi-casa-info/info')}
                                    </ControlLabel>
                                    <br/>
                                    <div className="clearfix">
                                        <Button
                                            bsStyle="primary"
                                            bsSize="xs"
                                            onClick={this.showConnectCubiCasaModal}
                                        >
                                            <i className="material-icons md-18">link</i>
                                            {Translate(
                                                'view-order/admin-planorder/cubi-casa-info/connect'
                                            )}
                                        </Button>
                                        <br/>
                                        <Button
                                            bsStyle="info"
                                            bsSize="xs"
                                            onClick={this.manualSyncCubiCasaOrder}
                                            disabled={this.state.loading}
                                        >
                                            <i className="material-icons md-18">autorenew</i>
                                            {Translate('view-order/admin-planorder/cubi-casa-info/sync')}
                                        </Button>
                                    </div>
                                    
                                    
                                    {this.props.planOrder.cubiCasaOrderId ? (
                                        <FormControl.Static>
                                            {Translate('view-order/admin-planorder/cubi-casa-info/order-status')}
                                            :
                                            {' ' +
                                                Translate(this.props.planOrder.cubiCasaOrderStatus.displayName)}
                                            <br />
                                            <a
                                                target="_blank"
                                                href={this.props.planOrder.cubiCasaOrderUrl}
                                            >
                                                {this.props.planOrder.cubiCasaOrderUrl}
                                            </a>
                                        </FormControl.Static>
                                    ) : null}
                                    {this.props.planOrder.cubiCasaOrderId && (
                                        <div className="clearfix">
                                            {this.canReturnToCubiCasa() && (
                                                <Button
                                                    bsStyle="danger"
                                                    bsSize="xs"
                                                    className="pull-right"
                                                    onClick={this.returnCubiCasaOrder}
                                                >
                                                    <i className="material-icons md-18">undo</i>
                                                    {Translate('view-order/admin-planorder/cubi-casa-info/return')}
                                                </Button>
                                            )}
                                            {this.canDeleteCubiCasaOrder() && (
                                                <Button
                                                    bsStyle="danger"
                                                    bsSize="xs"
                                                    className="pull-right"
                                                    onClick={this.deleteCubiCasaOrder}
                                                >
                                                    <i className="material-icons md-18 delete">
                                                        delete_forever
                                                    </i>
                                                    {Translate('view-order/admin-planorder/cubi-casa-info/delete')}
                                                </Button>
                                            )}
                                        </div>
                                    )}
                                </FormGroup>
                            ) : null}
                            <OrderRowsForm
                                orderId={this.props.orderId}
                                orderRows={this.props.planOrder.orderRows}
                                products={this.props.products}
                                removeOrderRow={this.removeOrderRow}
                                addOrderRow={this.addOrderRow}
                                editOrderRow={this.openEditOrderRow}
                            />
                        </Col>
                        <Col sm={4}>
                            {!this.isRoomSketcherOnly() && (
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup
                                            className="required"
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors['planUserId']
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate(
                                                    'view-order/admin-planorder/plan-firm-user'
                                                )}
                                            </ControlLabel>
                                            <FormSelect
                                                name="planUserId"
                                                value={
                                                    this.props.planOrder.planFirmId
                                                        ? this.props.planOrder.planFirmId.toString()
                                                        : ''
                                                }
                                                onChange={this.updatePlanFirm}
                                            >
                                                <option value="">
                                                    {Translate(
                                                        'view-order/admin-planorder/plan-firm-user/default-value'
                                                    )}
                                                </option>
                                                {this.props.planUserFirms.map((t: ISelect) => (
                                                    <option
                                                        key={'plan-firm-' + t.id}
                                                        value={t.id.toString()}
                                                    >
                                                        {t.name}
                                                    </option>
                                                ))}
                                            </FormSelect>
                                            <HelpBlock>{this.state.errors['planUserId']}</HelpBlock>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors['planEditorId']
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('view-order/admin-planorder/plan-edior')}
                                            </ControlLabel>
                                            <FormSelect
                                                name="planEditorId"
                                                value={
                                                    this.props.planOrder.planEditorId
                                                        ? this.props.planOrder.planEditorId.toString()
                                                        : ''
                                                }
                                                onChange={(e: any) =>
                                                    this.updatePlanEditor(e.target.value)
                                                }
                                            >
                                                <option value="">
                                                    {Translate(
                                                        'view-order/admin-planorder/plan-editor/default-value'
                                                    )}
                                                </option>
                                                {this.filterPlanEditorsByPlanFirm().map(
                                                    (t: ISelectPlanEditor) => (
                                                        <option
                                                            key={'plan-editor-' + t.id}
                                                            value={t.id.toString()}
                                                        >
                                                            {t.name}
                                                        </option>
                                                    )
                                                )}
                                            </FormSelect>
                                            <HelpBlock>
                                                {this.state.errors['planEditorId']}
                                            </HelpBlock>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            )}

                            {this.canGrabPlanOrder() && (
                                <Button onClick={this.grabPlanOrder}>
                                    {Translate('view-order/admin-planorder/grab')}
                                </Button>
                            )}

                            <FormGroup>
                                <ControlLabel>
                                    {Translate(
                                        'view-order/admin-planorder/plan-editor-information'
                                    )}
                                </ControlLabel>
                                <FormControl.Static>
                                    {this.props.planOrder.planEditorInformation}
                                </FormControl.Static>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>
                                    {Translate(
                                        'view-order/admin-planorder/plan-sketch-information'
                                    )}
                                </ControlLabel>
                                <FormControl.Static>
                                    {this.props.planOrder.planSketchInformation}
                                </FormControl.Static>
                            </FormGroup>
                            <FormGroup className="plan-extra-information">
                                <ControlLabel>
                                    {Translate('view-order/admin-planorder/extra-information')}
                                </ControlLabel>
                                <FormControl.Static>
                                    {this.props.planOrder.extraInformation}
                                </FormControl.Static>
                            </FormGroup>
                            {this.props.planOrder.returnedMessages &&
                                this.props.planOrder.returnedMessages.length > 0 && (
                                    <FormGroup className="plan-customer-returned-message">
                                        <ReturnedMessageText
                                            title={
                                                <ControlLabel>
                                                    {Translate(
                                                        'view-order/admin-planorder/customer-returned-message'
                                                    )}
                                                </ControlLabel>
                                            }
                                            returnedMessages={this.props.planOrder.returnedMessages}
                                            showSingleMessage={true}
                                        />
                                    </FormGroup>
                                )}
                            <InternalNotes
                                labels={
                                    {
                                        cancelButton: Translate('view-order/admin-planorder/internal-notes/button/cancel'),
                                        editButton: Translate('view-order/admin-planorder/internal-notes/button/edit'),
                                        saveButton: Translate('view-order/admin-planorder/internal-notes/button/save'),
                                        saveFailure: Translate('view-order/admin-planorder/internal-notes/saveFailure'),
                                        saveSuccess: Translate('view-order/admin-planorder/internal-notes/saveSuccess'),
                                        loadNotesFailure: Translate('view-order/admin-planorder/internal-notes/loadNotesFailure'),
                                        title: Translate(
                                            'view-order/admin-planorder/internal-notes/title'
                                        )
                                    } as InternalNotesLabels
                                }
                                user={this.props.user}
                                planOrderId={this.props.planOrder.id}
                            />
                        </Col>
                        <Col sm={4}>
                            <Row>
                                <Col sm={12}>
                                    <TemplatesForm
                                        templates={this.props.planOrder.templates}
                                        canGenerateTemplate={
                                            this.props.planOrder.canGenerateTemplate
                                        }
                                        isTemplateGenerationActive={
                                            this.props.planOrder.isTemplateGenerationActive
                                        }
                                        toggleTemplateGeneration={this.toggleTemplateGeneration}
                                    />

                                    <StatusForm
                                        sketchUpStatus={this.props.planOrder.sketchUpStatus}
                                        roomSketcherStatus={this.props.planOrder.roomSketcherStatus}
                                        user={this.props.user}
                                        hideDeliveryFailure={this.hideDeliveryFailure}
                                    />
                                    {((this.props.planOrder.sketchUpStatus &&
                                        this.props.planOrder.sketchUpStatus.id ===
                                            Status.scheduledForDelivery) ||
                                        (this.props.planOrder.roomSketcherStatus &&
                                            this.props.planOrder.roomSketcherStatus.id ===
                                                Status.scheduledForDelivery)) && (
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'view-order/admin/reset-scheduled-delivery-title'
                                                )}
                                            </ControlLabel>
                                            <FormControl.Static>
                                                {Moment(this.props.planOrder.deliveryDate).format(
                                                    'L LT'
                                                )}
                                            </FormControl.Static>
                                            <FormControl.Static>
                                                <Button
                                                    bsStyle="danger"
                                                    bsSize="sm"
                                                    onClick={this.resetScheduledDelivery}
                                                >
                                                    {Translate(
                                                        'view-order/admin/reset-scheduled-delivery-button'
                                                    )}
                                                </Button>
                                            </FormControl.Static>
                                        </FormGroup>
                                    )}
                                </Col>
                            </Row>

                            {this.canDeliver() && (
                                <Row>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate('order/plan/deliver/title')}
                                            </ControlLabel>
                                            <FormControl
                                                componentClass="textarea"
                                                name="message"
                                                value={
                                                    this.state.delivery.message
                                                        ? this.state.delivery.message
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Checkbox
                                                name="shouldAppendToEmail"
                                                checked={
                                                    this.state.delivery.shouldAppendToEmail
                                                        ? this.state.delivery.shouldAppendToEmail
                                                        : false
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            >
                                                <span>
                                                    {Translate(
                                                        'order/plan/deliver/should-append-to-email'
                                                    )}
                                                </span>
                                            </Checkbox>
                                        </FormGroup>
                                        <ValidatableFormGroup
                                            validationKey="deliveryDate"
                                            errors={this.state.errors}
                                        >
                                            <ControlLabel>
                                                {Translate('order/plan/deliver/automatic-delivery')}
                                            </ControlLabel>
                                            <Checkbox
                                                name="hasDate"
                                                checked={
                                                    this.state.delivery.hasDate
                                                        ? this.state.delivery.hasDate
                                                        : false
                                                }
                                                onChange={this.onHasDateChanged}
                                            >
                                                <span>
                                                    {Translate(
                                                        'order/plan/deliver/automatic-delivery/enable'
                                                    )}
                                                </span>
                                            </Checkbox>
                                            {this.state.delivery.hasDate && (
                                                <InputGroup>
                                                    <DateTime
                                                        inputProps={{
                                                            value: this.state.deliveryDateText
                                                        }}
                                                        locale={Moment.locale()}
                                                        value={this.state.delivery.deliveryDate}
                                                        onChange={this.onDateTimeChange}
                                                        isValidDate={(current) => {
                                                            return current.isAfter(
                                                                Moment().subtract(1, 'day')
                                                            );
                                                        }}
                                                    />
                                                    <InputGroup.Button>
                                                        <Button
                                                            bsSize="sm"
                                                            onClick={() =>
                                                                this.setDeliveryDateFromNow(0)
                                                            }
                                                        >
                                                            {Translate(
                                                                'order/plan/deliver/today-button'
                                                            )}
                                                        </Button>
                                                        <Button
                                                            bsSize="sm"
                                                            onClick={() =>
                                                                this.setDeliveryDateFromNow(1)
                                                            }
                                                        >
                                                            {Translate(
                                                                'order/plan/deliver/tomorrow-button'
                                                            )}
                                                        </Button>
                                                    </InputGroup.Button>
                                                </InputGroup>
                                            )}
                                        </ValidatableFormGroup>
                                        <Button
                                            bsStyle="success"
                                            className="pull-right"
                                            disabled={
                                                this.state.delivery.hasDate &&
                                                !this.state.validDeliveryDate
                                            }
                                            onClick={this.deliver}
                                        >
                                            {Translate('order/plan/deliver/button')}
                                        </Button>
                                    </Col>
                                </Row>
                            )}

                            {this.canResetDelivery() && (
                                <Row>
                                    <Col sm={12}>
                                        <Panel bsStyle="default">
                                            <Panel.Heading>
                                                {Translate('order/plan/reset-delivery/header')}
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <Row>
                                                    <Col xs={9}>
                                                        {Translate(
                                                            'order/plan/reset-delivery/description'
                                                        )}
                                                    </Col>
                                                    <Col xs={3}>
                                                        <Button
                                                            bsStyle="danger"
                                                            className="pull-right"
                                                            onClick={() =>
                                                                this.setState({
                                                                    showResetDeliveryConfirmationModal:
                                                                        true
                                                                } as IState)
                                                            }
                                                        >
                                                            {Translate(
                                                                'order/plan/reset-delivery/button-label'
                                                            )}
                                                        </Button>
                                                        {this.canStopDelivery() && (
                                                            <Button
                                                                bsStyle="default"
                                                                className="pull-right"
                                                                onClick={() =>
                                                                    this.setState({
                                                                        showStopDeliveryConfirmationModal:
                                                                            true
                                                                    } as IState)
                                                                }
                                                            >
                                                                {Translate(
                                                                    'order/plan/stop-delivery/button-label'
                                                                )}
                                                            </Button>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>
                    {this.state.showOrder && (
                        <Row>
                            <ButtonGroup className="col-sm-12 nobreak-right">
                                {this.isDelivered() && (
                                    <Button onClick={this.emailFiles}>
                                        {Translate('order/plan/admin/email-files')}
                                    </Button>
                                )}
                                {this.isDelivered() && (
                                    <Button onClick={this.email}>
                                        {Translate('order/plan/admin/email')}
                                    </Button>
                                )}
                                {this.canSendPlanOrder() && (
                                    <Button
                                        bsStyle="primary"
                                        className="pull-right"
                                        onClick={this.sendForCustomer}
                                        disabled={this.state.isSending}
                                    >
                                        {Translate('order/plan/send-button')}{' '}
                                        {this.state.isSending && <i className="load-spin-dark"></i>}
                                    </Button>
                                )}

                                {this.canSendToPlanOrReturnToBroker() && (
                                    <Button
                                        bsStyle="danger"
                                        onClick={this.returnToBroker}
                                        disabled={this.state.isSending}
                                    >
                                        {Translate(
                                            'view-order/admin-planorder/return/broker-button'
                                        )}{' '}
                                        {this.state.isSending && <i className="load-spin-dark"></i>}
                                    </Button>
                                )}

                                {this.canSendToPlanOrReturnToBroker() && (
                                    <Button
                                        bsStyle="primary"
                                        onClick={this.sendToPlanFirm}
                                        disabled={this.state.isSending}
                                    >
                                        {Translate(
                                            'view-order/admin-planorder/send-to-plan-firm-button'
                                        )}{' '}
                                        {this.state.isSending && <i className="load-spin-dark"></i>}
                                    </Button>
                                )}

                                {(this.roomsketcherStatusIs(Status.returned) ||
                                    this.sketchupStatusIsAny([Status.returned, Status.ready])) && (
                                    <DropdownButton
                                        id="set-as-delivered-button"
                                        title={Translate(
                                            'view-order/admin-planorder/reset-to-delivered-dropdown'
                                        )}
                                    >
                                        {this.sketchupStatusIsAny([
                                            Status.returned,
                                            Status.ready
                                        ]) && (
                                            <MenuItem
                                                eventKey="1"
                                                onClick={() =>
                                                    this.setSketchupStatusTo(Status.delivered)
                                                }
                                            >
                                                {Translate(
                                                    'view-order/admin-planorder/sketchup/reset-to-delivered-button'
                                                )}
                                            </MenuItem>
                                        )}
                                        {this.roomsketcherStatusIs(Status.returned) && (
                                            <MenuItem
                                                eventKey="2"
                                                onClick={() =>
                                                    this.setRoomsketcherStatusTo(Status.delivered)
                                                }
                                            >
                                                {Translate(
                                                    'view-order/admin-planorder/roomsketcher/reset-to-delivered-button'
                                                )}
                                            </MenuItem>
                                        )}
                                    </DropdownButton>
                                )}
                                <Button bsStyle="info" onClick={this.downloadFiles}>
                                    <i className="material-icons md-18">cloud_download</i>{' '}
                                    {Translate('order/plan/storey/download-button')}
                                </Button>

                                {this.canGenerate() && (
                                    <Button
                                        bsStyle="info"
                                        onClick={this.generateFiles}
                                        disabled={this.state.isGenerating}
                                    >
                                        {Translate('plan-order/delivery/generate-files-button')}
                                        {this.state.isGenerating && (
                                            <i className="load-spin-dark"></i>
                                        )}
                                    </Button>
                                )}

                                {this.canApprove() && (
                                    <Button onClick={this.approvePlanOrder} bsStyle="success">
                                        {Translate('plan-order/delivery/approve-button')}
                                    </Button>
                                )}

                                <ReturnButton
                                    isSketchUp={this.is(
                                        this.props.planOrder.sketchUpStatus
                                            ? this.props.planOrder.sketchUpStatus.id
                                            : 0
                                    )}
                                    isRoomSketcher={this.is(
                                        this.props.planOrder.roomSketcherStatus
                                            ? this.props.planOrder.roomSketcherStatus.id
                                            : 0
                                    )}
                                    return={this.return}
                                    returnSketchUp={this.returnSketchUp}
                                    returnRoomSketcher={this.returnRoomSketcher}
                                    canReturn={this.canReturnOrder()}
                                    canReturnSketchUp={this.canReturnToPlan(
                                        this.props.planOrder.sketchUpStatus
                                    )}
                                    canReturnRoomSketcher={this.canReturnToPlan(
                                        this.props.planOrder.roomSketcherStatus
                                    )}
                                />
                            </ButtonGroup>
                        </Row>
                    )}
                    {!this.state.showOrder && this.state.showGetPlanOrderFilesButton && (
                        <Row>
                            <Col>
                                <div className="col-sm-4 nobreak-right pull-right">
                                    <Panel>
                                        <Panel.Heading>
                                            <Panel.Title>
                                                <div>
                                                    {Translate(
                                                        'view-order/admin-planorder/show-planorder-info/panel/header'
                                                    )}
                                                </div>
                                            </Panel.Title>
                                        </Panel.Heading>

                                        <Panel.Body className="info-blue">
                                            <div>
                                                {Translate(
                                                    'view-order/admin-planorder/show-planorder-info/panel/text'
                                                )}
                                                <br />
                                                <Button
                                                    bsStyle="success"
                                                    onClick={this.showPlanOrder}
                                                >
                                                    {Translate(
                                                        'view-order/admin-planorder/show-planorder-info/panel/button-label/retrieve-order-info'
                                                    )}
                                                </Button>

                                                <Button
                                                    bsStyle="warning"
                                                    className="right"
                                                    onClick={this.resetPlanOrderArchiveState}
                                                >
                                                    {Translate(
                                                        'view-order/admin-planorder/show-planorder-info/panel/button-label/reset-order-info'
                                                    )}
                                                </Button>
                                            </div>
                                        </Panel.Body>
                                    </Panel>
                                </div>
                            </Col>
                        </Row>
                    )}
                </fieldset>
                <div>
                    <h2>{Translate('view-order/admin-planorder/plan-sketches')}</h2>

                    {this.props.planOrder.stories &&
                        this.props.planOrder.stories.map((storey, index) => (
                            <div className="plan-sketch-storeys" key={'storey-' + storey.id}>
                                <div className="storey-tools">
                                    <StoreySort
                                        index={index}
                                        storiesLength={this.props.planOrder.stories.length}
                                        moveUp={() => this.updateSort(storey.id, 'up')}
                                        moveDown={() => this.updateSort(storey.id, 'down')}
                                    />
                                    <FormGroup
                                        className="required storey-select"
                                        validationState={FormValidationService.getValidationState(
                                            this.state.errors[`stories[${index}]`]
                                        )}
                                    >
                                        <StoreySelect
                                            key={'storey-select-' + index}
                                            value={{
                                                id: storey.storeyId,
                                                name:
                                                    storey.customStoreyName === null
                                                        ? Translate(storey.storeyName)
                                                        : storey.customStoreyName
                                            }}
                                            options={storey.availableStories}
                                            onChange={(e: any) => this.onChangeStorey(e, index)}
                                        />
                                        <HelpBlock>
                                            {this.state.errors[`stories[${index}]`]}
                                        </HelpBlock>
                                    </FormGroup>
                                    <ButtonToolbar className="">
                                        <Button
                                            bsStyle="danger"
                                            onClick={() => this.deleteStorey(storey.id)}
                                        >
                                            <i className="material-icons md-18 delete">
                                                delete_forever
                                            </i>{' '}
                                            {Translate('order/plan/storey/delete-button')}
                                        </Button>
                                        <Button
                                            bsStyle="success"
                                            onClick={() => this.openStoreyExternalFileModal(index)}
                                        >
                                            {Translate('order/plan/storey/external-files-button')} (
                                            {storey.externalFiles ? storey.externalFiles.length : 0}
                                            )
                                        </Button>
                                    </ButtonToolbar>
                                </div>
                                <Row className="plan-sketch-storey-row">
                                    <Col md={2}>
                                        <BlueprintFile
                                            thumbnailReference={
                                                storey.file ? storey.file.thumbnailReference : null
                                            }
                                            createdByAdmin={
                                                storey.file ? storey.file.createdByAdmin : null
                                            }
                                            hasAnnotation={
                                                storey.blueprint !== undefined &&
                                                storey.blueprint !== null
                                            }
                                            onAnnotate={() => this.annotateStorey(storey.file.id)}
                                            onDelete={() => this.deleteStorey(storey.id)}
                                            onClick={() => this.onSelectImage(storey.file, false)}
                                            showBlueprint={storey.originalBlueprint ? true : false}
                                            onShowBlueprint={() =>
                                                this.onSelectImage(storey.originalBlueprint, false)
                                            }
                                            actionUrl={`${apiUrl}/views/planorder/${this.props.planOrder.id}/file/storey/${storey.id}/blueprint`}
                                            isLocked={
                                                this.isFileLocked(
                                                    this.props.planOrder.sketchUpStatus.id
                                                ) ||
                                                this.isFileLocked(
                                                    this.props.planOrder.roomSketcherStatus.id
                                                )
                                            }
                                            upload={
                                                this.state.storiesUploads[storey.id]
                                                    ? this.state.storiesUploads[storey.id].blueprint
                                                    : false
                                            }
                                            onUploadCompleted={() =>
                                                this.onStoreyFilesUploadCompleted(
                                                    storey.id,
                                                    'blueprint'
                                                )
                                            }
                                            onFileUploadCompleted={(response: any) =>
                                                this.onStoreyFileUploadCompleted(
                                                    response,
                                                    storey.id,
                                                    this.props.actions
                                                        .addPlanOrderStoreyBlueprintFile
                                                )
                                            }
                                            onUpload={() =>
                                                this.uploadStoreyFile(storey.id, 'blueprint')
                                            }
                                            dropzoneId={'blueprint-dropzone-' + storey.id}
                                            originalCreatedByRole={
                                                storey.file
                                                    ? storey.file.originalCreatedByRole
                                                    : null
                                            }
                                        />
                                    </Col>
                                    <Col md={10} className="no-padding">
                                        <Row>
                                            {(this.props.planOrder.sketchUp2D ||
                                                this.props.planOrder.sketchUp3D) && (
                                                <Col md={6}>
                                                    <Col md={6}>
                                                        {this.props.planOrder.sketchUp2D && (
                                                            <StoreyFile
                                                                thumbnailReference={
                                                                    storey.file2D
                                                                        ? storey.file2D
                                                                              .thumbnailReference
                                                                        : null
                                                                }
                                                                title={Translate(
                                                                    'order/plan/storey/2d-title'
                                                                )}
                                                                onAnnotate={() =>
                                                                    this.annotateStorey(
                                                                        storey.file2D.id
                                                                    )
                                                                }
                                                                onEditTexts={() =>
                                                                    this.annotateTexts(
                                                                        storey.file2D.id
                                                                    )
                                                                }
                                                                onCompare={() =>
                                                                    this.onSelectCompareImage(
                                                                        storey.id,
                                                                        PlanOrderStoreyFileType.sketchUp2D,
                                                                        false
                                                                    )
                                                                }
                                                                onClick={() =>
                                                                    this.onSelectImage(
                                                                        storey.file2D,
                                                                        false
                                                                    )
                                                                }
                                                                dropzoneId={
                                                                    'storey-sketchup-2d-' + index
                                                                }
                                                                actionUrl={`${apiUrl}/views/planorder/${this.props.planOrder.id}/file/storey/${storey.id}/sketchup/2d`}
                                                                upload={
                                                                    this.state.storiesUploads[
                                                                        storey.id
                                                                    ]
                                                                        ? this.state.storiesUploads[
                                                                              storey.id
                                                                          ].sketchUp2D
                                                                        : false
                                                                }
                                                                onUploadCompleted={() =>
                                                                    this.onStoreyFilesUploadCompleted(
                                                                        storey.id,
                                                                        'sketchUp2D',
                                                                        'showSketchUp2D'
                                                                    )
                                                                }
                                                                onFileUploadCompleted={(
                                                                    response: any
                                                                ) =>
                                                                    this.onStoreyFileUploadCompleted(
                                                                        response,
                                                                        storey.id,
                                                                        this.props.actions
                                                                            .addPlanOrderStoreySketchUp2DFile
                                                                    )
                                                                }
                                                                onUpload={() =>
                                                                    this.uploadStoreyFile(
                                                                        storey.id,
                                                                        'sketchUp2D'
                                                                    )
                                                                }
                                                                uploadModalTitle={Translate(
                                                                    'order/plan/storey/upload-sketchup-2d-title'
                                                                )}
                                                                showUploadModal={
                                                                    this.state.storiesUploads[
                                                                        storey.id
                                                                    ]
                                                                        ? this.state.storiesUploads[
                                                                              storey.id
                                                                          ].showSketchUp2D
                                                                        : false
                                                                }
                                                                onShowUploadModal={() =>
                                                                    this.onShowStoreyFileUploadModal(
                                                                        storey.id,
                                                                        'showSketchUp2D'
                                                                    )
                                                                }
                                                                onUploadModalClose={() =>
                                                                    this.onStoreyFilesUploadCompleted(
                                                                        storey.id,
                                                                        'showSketchUp2D'
                                                                    )
                                                                }
                                                                isAnnotation={
                                                                    storey.file2D &&
                                                                    storey.file2D.isAnnotation
                                                                }
                                                                displayTemplateGenerationButtons={
                                                                    this.props.planOrder
                                                                        .isTemplateGenerationActive
                                                                }
                                                                isLocked={this.isFileLocked(
                                                                    this.props.planOrder
                                                                        .sketchUpStatus.id
                                                                )}
                                                            />
                                                        )}
                                                    </Col>
                                                    <Col md={6}>
                                                        {this.props.planOrder.sketchUp3D && (
                                                            <StoreyFile
                                                                thumbnailReference={
                                                                    storey.file3D
                                                                        ? storey.file3D
                                                                              .thumbnailReference
                                                                        : null
                                                                }
                                                                title={Translate(
                                                                    'order/plan/storey/3d-title'
                                                                )}
                                                                onAnnotate={() =>
                                                                    this.annotateStorey(
                                                                        storey.file3D.id
                                                                    )
                                                                }
                                                                onEditTexts={() =>
                                                                    this.annotateTexts(
                                                                        storey.file3D.id
                                                                    )
                                                                }
                                                                onCompare={() =>
                                                                    this.onSelectCompareImage(
                                                                        storey.id,
                                                                        PlanOrderStoreyFileType.sketchUp3D,
                                                                        false
                                                                    )
                                                                }
                                                                onClick={() =>
                                                                    this.onSelectImage(
                                                                        storey.file3D,
                                                                        false
                                                                    )
                                                                }
                                                                dropzoneId={
                                                                    'storey-sketchup-3d-' + index
                                                                }
                                                                actionUrl={`${apiUrl}/views/planorder/${this.props.planOrder.id}/file/storey/${storey.id}/sketchup/3d`}
                                                                upload={
                                                                    this.state.storiesUploads[
                                                                        storey.id
                                                                    ]
                                                                        ? this.state.storiesUploads[
                                                                              storey.id
                                                                          ].sketchUp3D
                                                                        : false
                                                                }
                                                                onUploadCompleted={() =>
                                                                    this.onStoreyFilesUploadCompleted(
                                                                        storey.id,
                                                                        'sketchUp3D',
                                                                        'showSketchUp3D'
                                                                    )
                                                                }
                                                                onFileUploadCompleted={(
                                                                    response: any
                                                                ) =>
                                                                    this.onStoreyFileUploadCompleted(
                                                                        response,
                                                                        storey.id,
                                                                        this.props.actions
                                                                            .addPlanOrderStoreySketchUp3DFile
                                                                    )
                                                                }
                                                                onUpload={() =>
                                                                    this.uploadStoreyFile(
                                                                        storey.id,
                                                                        'sketchUp3D'
                                                                    )
                                                                }
                                                                uploadModalTitle={Translate(
                                                                    'order/plan/storey/upload-sketchup-3d-title'
                                                                )}
                                                                showUploadModal={
                                                                    this.state.storiesUploads[
                                                                        storey.id
                                                                    ]
                                                                        ? this.state.storiesUploads[
                                                                              storey.id
                                                                          ].showSketchUp3D
                                                                        : false
                                                                }
                                                                onShowUploadModal={() =>
                                                                    this.onShowStoreyFileUploadModal(
                                                                        storey.id,
                                                                        'showSketchUp3D'
                                                                    )
                                                                }
                                                                onUploadModalClose={() =>
                                                                    this.onStoreyFilesUploadCompleted(
                                                                        storey.id,
                                                                        'showSketchUp3D'
                                                                    )
                                                                }
                                                                isAnnotation={
                                                                    storey.file3D &&
                                                                    storey.file3D.isAnnotation
                                                                }
                                                                displayTemplateGenerationButtons={
                                                                    this.props.planOrder
                                                                        .isTemplateGenerationActive
                                                                }
                                                                isLocked={this.isFileLocked(
                                                                    this.props.planOrder
                                                                        .sketchUpStatus.id
                                                                )}
                                                            />
                                                        )}
                                                    </Col>
                                                </Col>
                                            )}
                                            {(this.props.planOrder.roomSketcher2D ||
                                                this.props.planOrder.roomSketcher3D) && (
                                                <Col md={6}>
                                                    <Col md={6}>
                                                        {this.props.planOrder.roomSketcher2D && (
                                                            <StoreyFile
                                                                thumbnailReference={
                                                                    storey.roomSketcherFile2D
                                                                        ? storey.roomSketcherFile2D
                                                                              .thumbnailReference
                                                                        : null
                                                                }
                                                                title={Translate(
                                                                    'order/plan/storey/room-sketcher-2d-title'
                                                                )}
                                                                onAnnotate={() =>
                                                                    this.annotateStorey(
                                                                        storey.roomSketcherFile2D.id
                                                                    )
                                                                }
                                                                onEditTexts={() =>
                                                                    this.annotateTexts(
                                                                        storey.roomSketcherFile2D.id
                                                                    )
                                                                }
                                                                onCompare={() =>
                                                                    this.onSelectCompareImage(
                                                                        storey.id,
                                                                        PlanOrderStoreyFileType.roomSketcher2D,
                                                                        false
                                                                    )
                                                                }
                                                                onClick={() =>
                                                                    this.onSelectImage(
                                                                        storey.roomSketcherFile2D,
                                                                        false
                                                                    )
                                                                }
                                                                dropzoneId={
                                                                    'storey-roomsketcher-2d-' +
                                                                    index
                                                                }
                                                                actionUrl={`${apiUrl}/views/planorder/${this.props.planOrder.id}/file/storey/${storey.id}/roomsketcher/2d`}
                                                                upload={
                                                                    this.state.storiesUploads[
                                                                        storey.id
                                                                    ]
                                                                        ? this.state.storiesUploads[
                                                                              storey.id
                                                                          ].roomSketcher2D
                                                                        : false
                                                                }
                                                                onUploadCompleted={() =>
                                                                    this.onStoreyFilesUploadCompleted(
                                                                        storey.id,
                                                                        'roomSketcher2D',
                                                                        'showRoomSketcher2D'
                                                                    )
                                                                }
                                                                onFileUploadCompleted={(
                                                                    response: any
                                                                ) =>
                                                                    this.onStoreyFileUploadCompleted(
                                                                        response,
                                                                        storey.id,
                                                                        this.props.actions
                                                                            .addPlanOrderStoreyRoomSketcher2DFile
                                                                    )
                                                                }
                                                                onUpload={() =>
                                                                    this.uploadStoreyFile(
                                                                        storey.id,
                                                                        'roomSketcher2D'
                                                                    )
                                                                }
                                                                uploadModalTitle={Translate(
                                                                    'order/plan/storey/upload-roomsketcher-2d-title'
                                                                )}
                                                                showUploadModal={
                                                                    this.state.storiesUploads[
                                                                        storey.id
                                                                    ]
                                                                        ? this.state.storiesUploads[
                                                                              storey.id
                                                                          ].showRoomSketcher2D
                                                                        : false
                                                                }
                                                                onShowUploadModal={() =>
                                                                    this.onShowStoreyFileUploadModal(
                                                                        storey.id,
                                                                        'showRoomSketcher2D'
                                                                    )
                                                                }
                                                                onUploadModalClose={() =>
                                                                    this.onStoreyFilesUploadCompleted(
                                                                        storey.id,
                                                                        'showRoomSketcher2D'
                                                                    )
                                                                }
                                                                isAnnotation={
                                                                    storey.roomSketcherFile2D &&
                                                                    storey.roomSketcherFile2D
                                                                        .isAnnotation
                                                                }
                                                                displayTemplateGenerationButtons={
                                                                    false
                                                                }
                                                                isLocked={this.isFileLocked(
                                                                    this.props.planOrder
                                                                        .roomSketcherStatus.id
                                                                )}
                                                            />
                                                        )}
                                                    </Col>
                                                    <Col md={6}>
                                                        {this.props.planOrder.roomSketcher3D && (
                                                            <StoreyFile
                                                                thumbnailReference={
                                                                    storey.roomSketcherFile3D
                                                                        ? storey.roomSketcherFile3D
                                                                              .thumbnailReference
                                                                        : null
                                                                }
                                                                title={Translate(
                                                                    'order/plan/storey/room-sketcher-3d-title'
                                                                )}
                                                                onAnnotate={() =>
                                                                    this.annotateStorey(
                                                                        storey.roomSketcherFile3D.id
                                                                    )
                                                                }
                                                                onEditTexts={() =>
                                                                    this.annotateTexts(
                                                                        storey.roomSketcherFile3D.id
                                                                    )
                                                                }
                                                                onCompare={() =>
                                                                    this.onSelectCompareImage(
                                                                        storey.id,
                                                                        PlanOrderStoreyFileType.roomSketcher3D,
                                                                        false
                                                                    )
                                                                }
                                                                onClick={() =>
                                                                    this.onSelectImage(
                                                                        storey.roomSketcherFile3D,
                                                                        false
                                                                    )
                                                                }
                                                                dropzoneId={
                                                                    'storey-roomsketcher-3d-' +
                                                                    index
                                                                }
                                                                actionUrl={`${apiUrl}/views/planorder/${this.props.planOrder.id}/file/storey/${storey.id}/roomsketcher/3d`}
                                                                upload={
                                                                    this.state.storiesUploads[
                                                                        storey.id
                                                                    ]
                                                                        ? this.state.storiesUploads[
                                                                              storey.id
                                                                          ].roomSketcher3D
                                                                        : false
                                                                }
                                                                onUploadCompleted={() =>
                                                                    this.onStoreyFilesUploadCompleted(
                                                                        storey.id,
                                                                        'roomSketcher3D',
                                                                        'showRoomSketcher3D'
                                                                    )
                                                                }
                                                                onFileUploadCompleted={(
                                                                    response: any
                                                                ) =>
                                                                    this.onStoreyFileUploadCompleted(
                                                                        response,
                                                                        storey.id,
                                                                        this.props.actions
                                                                            .addPlanOrderStoreyRoomSketcher3DFile
                                                                    )
                                                                }
                                                                onUpload={() =>
                                                                    this.uploadStoreyFile(
                                                                        storey.id,
                                                                        'roomSketcher3D'
                                                                    )
                                                                }
                                                                uploadModalTitle={Translate(
                                                                    'order/plan/storey/upload-roomsketcher-3d-title'
                                                                )}
                                                                showUploadModal={
                                                                    this.state.storiesUploads[
                                                                        storey.id
                                                                    ]
                                                                        ? this.state.storiesUploads[
                                                                              storey.id
                                                                          ].showRoomSketcher3D
                                                                        : false
                                                                }
                                                                onShowUploadModal={() =>
                                                                    this.onShowStoreyFileUploadModal(
                                                                        storey.id,
                                                                        'showRoomSketcher3D'
                                                                    )
                                                                }
                                                                onUploadModalClose={() =>
                                                                    this.onStoreyFilesUploadCompleted(
                                                                        storey.id,
                                                                        'showRoomSketcher3D'
                                                                    )
                                                                }
                                                                isAnnotation={
                                                                    storey.roomSketcherFile3D &&
                                                                    storey.roomSketcherFile3D
                                                                        .isAnnotation
                                                                }
                                                                displayTemplateGenerationButtons={
                                                                    false
                                                                }
                                                                isLocked={this.isFileLocked(
                                                                    this.props.planOrder
                                                                        .roomSketcherStatus.id
                                                                )}
                                                            />
                                                        )}
                                                    </Col>
                                                </Col>
                                            )}
                                        </Row>
                                    </Col>
                                </Row>
                                <hr />
                            </div>
                        ))}
                    <Row>
                        <Col md={12}>
                            <CheckDelivery
                                stories={this.props.planOrder.stories}
                                delivery={this.props.planOrder.delivery}
                                shouldGenerate={this.canGenerate}
                                isGenerating={this.state.isGenerating}
                                generate={this.generateFiles}
                                canApprove={this.canApprove}
                                approve={this.approvePlanOrder}
                                onSelectImage={this.onSelectImage}
                                isLocked={
                                    this.isFileLocked(
                                        this.props.planOrder.sketchUpStatus
                                            ? this.props.planOrder.sketchUpStatus.id
                                            : 0
                                    ) ||
                                    this.isFileLocked(
                                        this.props.planOrder.roomSketcherStatus
                                            ? this.props.planOrder.roomSketcherStatus.id
                                            : 0
                                    )
                                }
                                user={this.props.user}
                                inActivateExternalFile={this.inActivateExternalFile}
                                deleteDeliveryFile={this.deleteDeliveryFile}
                                annotateExternalFile={this.annotateExternalFile}
                                annotateExternalDeliveryFile={this.annotateExternalDeliveryFile}
                                annotateDeliveryFile={this.annotateDeliveryFile}
                            />
                        </Col>
                    </Row>

                    {this.props.planOrder.id && (
                        <Row className="plan-sketch-storeys">
                            <Col md={6}>
                                <fieldset className="planeditor-fieldset">
                                    <legend>{Translate('order/plan/new-storey-title')}</legend>
                                    <div className="button-bar-below">
                                        <div className="content-row">
                                            {!this.isFileLocked(
                                                this.props.planOrder.sketchUpStatus.id
                                            ) &&
                                                !this.isFileLocked(
                                                    this.props.planOrder.roomSketcherStatus.id
                                                ) && (
                                                    <Dropzone
                                                        actionUrl={`${apiUrl}/views/planorder/${this.props.planOrder.id}/storey`}
                                                        upload={this.state.upload}
                                                        onUploadCompleted={this.onUploadCompleted}
                                                        onFileUploadCompleted={
                                                            this.onFileUploadCompleted
                                                        }
                                                        uploadMultiple={true}
                                                        removeFileAfterSuccess={true}
                                                        acceptedFiles={
                                                            'application/pdf,image/jpeg,image/png,image/gif'
                                                        }
                                                    />
                                                )}
                                        </div>
                                        <div className="button-row">
                                            {!this.isFileLocked(
                                                this.props.planOrder.sketchUpStatus.id
                                            ) &&
                                                !this.isFileLocked(
                                                    this.props.planOrder.roomSketcherStatus.id
                                                ) && (
                                                    <Button
                                                        bsSize="sm"
                                                        bsStyle="info"
                                                        className="pull-right"
                                                        onClick={this.uploadFiles}
                                                    >
                                                        <i className="material-icons">
                                                            cloud_upload
                                                        </i>{' '}
                                                        {Translate('order/plan/upload-button')}
                                                    </Button>
                                                )}
                                            <Button
                                                bsSize="sm"
                                                bsStyle="success"
                                                className="pull-right"
                                                onClick={this.createEmptyStorey}
                                            >
                                                <i className="material-icons">add</i>
                                                {Translate('order/plan/create-empty-storey-button')}
                                            </Button>
                                        </div>
                                    </div>
                                </fieldset>
                            </Col>
                            <Col md={6}>
                                <ExternalFilesForm
                                    selectedFile={this.state.selectedPlanOrderInternalExternalFile}
                                    onSelectedFileChanged={(e: any) =>
                                        this.uploadedPlanOrderInternalExternalFilesChanged(e)
                                    }
                                    files={this.props.planOrder.internalExternalFiles}
                                    onDeleteFile={() =>
                                        this.deletePlanOrderInternalExternalFile(
                                            this.props.planOrder.internalExternalFiles[
                                                this.state.selectedPlanOrderInternalExternalFile
                                            ]
                                        )
                                    }
                                    onFileUploadCompleted={
                                        this.onPlanOrderInternalExternalFileUploadCompleted
                                    }
                                    selectedSecondaryFile={
                                        this.state.selectedPlanOrderExternalDeliveryFile
                                    }
                                    onSelectedSecondaryFileChanged={(e: any) =>
                                        this.uploadedPlanOrderExternalDeliveryFilesChanged(e)
                                    }
                                    secondaryFiles={this.props.planOrder.externalDeliveryFiles}
                                    onDeleteSecondaryFile={() =>
                                        this.deletePlanOrderExternalDeliveryFile(
                                            this.props.planOrder.externalDeliveryFiles[
                                                this.state.selectedPlanOrderExternalDeliveryFile
                                            ]
                                        )
                                    }
                                    onSecondaryFileUploadCompleted={
                                        this.onPlanOrderExternalDeliveryFileUploadCompleted
                                    }
                                    dropzoneId={'dropzone-plan-order'}
                                    actionUrl={`${apiUrl}/views/planorder/${this.props.planOrder.id}/file/0`}
                                    actionUrlToCustomer={`${apiUrl}/views/planorder/${this.props.planOrder.id}/file/1`}
                                    upload={this.state.planOrderInternalExternalFilesUpload}
                                    uploadToCustomer={
                                        this.state.planOrderExternalFilesUploadToCustomer
                                    }
                                    onUploadCompleted={this.onPlanOrderExternalFilesUploadCompleted}
                                    onUpload={this.uploadPlanOrderExternalFiles}
                                    onUploadToCustomer={this.uploadPlanOrderExternalFilesToCustomer}
                                    title={Translate('order/plan/external-files-title')}
                                />
                            </Col>
                        </Row>
                    )}
                </div>

                {this.state.showAnnotationModal && this.props.annotation && (
                    <PlanAnnotationTool
                        annotation={this.props.annotation}
                        save={this.saveAnnotation}
                        storeys={this.props.planOrder.stories}
                        close={() =>
                            this.setState({
                                showAnnotationModal: false,
                                fontSizeRatioForTextEdit: null
                            } as IState)
                        }
                        commonTexts={this.props.planOrder.annotationTextInfo.commonTexts}
                        fontFamily={this.props.planOrder.annotationTextInfo.font}
                        upperCase={this.props.planOrder.annotationTextInfo.upperCase}
                        type={this.state.selectedAnnotationType}
                        user={this.props.user}
                        address={this.props.planOrder.address}
                        changeFile={(id: number) =>
                            this.showAnnotationModal(id, this.state.selectedAnnotationType)
                        }
                        showFilePlacementsModal={
                            this.canAnnotatePlacement()
                                ? (planOrderStoreyFileId: number) =>
                                      this.showFilePlacementsModal(planOrderStoreyFileId)
                                : null
                        }
                        fontSizeRatio={this.state.fontSizeRatioForTextEdit}
                        extraInformation={this.props.planOrder.extraInformation}
                        returnedMessages={this.props.planOrder.returnedMessages}
                    />
                )}
                {this.state.showFilePlacementsModal && (
                    <FilePlacementsModal
                        planOrderId={this.props.planOrder.id}
                        images2D={this.props.planOrder.stories
                            .filter((x) => x.file2D)
                            .map((x) => x.file2D)}
                        images3D={this.props.planOrder.stories
                            .filter((x) => x.file3D)
                            .map((x) => x.file3D)}
                        closeModal={() =>
                            this.setState({
                                showFilePlacementsModal: false
                            } as IState)
                        }
                        onSave={(files: any[]) =>
                            this.savePlacements(
                                files,
                                this.state.placementModalPlanOrderStoreyFileId
                            )
                        }
                    />
                )}
                {this.state.showImageModal && this.state.selectedImage && (
                    <ImageModal
                        filename={this.state.selectedImage.filename}
                        fileReference={this.state.selectedImage.fileReference}
                        onClose={() => {
                            this.setState({
                                showImageModal: false,
                                selectedImage: null
                            } as IState);
                        }}
                    />
                )}
                {this.state.showImageModal &&
                    this.state.selectedImage &&
                    this.state.deliveryFileWasSelected && (
                        <ImageModal
                            filename={this.state.selectedImage.filename}
                            fileReference={this.state.selectedImage.fileReference}
                            onClose={() => {
                                this.setState({
                                    showImageModal: false,
                                    selectedImage: null,
                                    deliveryFileWasSelected: false
                                } as IState);
                            }}
                        />
                    )}
                {this.state.showCompareModal &&
                    this.state.storiesForCompare &&
                    this.state.storiesForCompare.length > 0 && (
                        <CompareImageModal
                            storeys={this.state.storiesForCompare}
                            selectedStoreyId={this.state.selectedStoreyIdForCompare}
                            selectedStoreyFileType={this.state.selectedStoreyFileType}
                            onClose={() => {
                                this.setState({
                                    showCompareModal: false
                                } as IState);
                            }}
                            onFilterChanged={this.onCompareFilterChanged}
                            extraInformation={this.props.planOrder.extraInformation}
                            returnedMessages={this.props.planOrder.returnedMessages}
                            address={this.props.planOrder.address}
                        />
                    )}
                {this.state.showStoreyExternalFilesModal && (
                    <StoreyExternalFilesModal
                        title={Translate('order/plan/storey/external-files-button')}
                        selectedFiles={this.state.selectedExternalStoreyFile}
                        externalFiles={
                            this.props.planOrder.stories[this.state.selectedExternalStoreyIndex]
                                .externalFiles
                        }
                        dropzoneId={'dropzone-storey-' + this.state.selectedExternalStoreyIndex}
                        actionUrl={`${apiUrl}/views/planorder/${
                            this.props.planOrder.id
                        }/file/storey/${
                            this.props.planOrder.stories[this.state.selectedExternalStoreyIndex].id
                        }`}
                        upload={
                            this.state.storiesUploads[
                                this.props.planOrder.stories[this.state.selectedExternalStoreyIndex]
                                    .id
                            ]
                                ? this.state.storiesUploads[
                                      this.props.planOrder.stories[
                                          this.state.selectedExternalStoreyIndex
                                      ].id
                                  ].external
                                : false
                        }
                        uploadedFilesChanged={(e: any) => this.uploadedFilesChanged(e)}
                        onDeleteFile={this.deletePlanOrderStoreyExternalFile}
                        onUploadCompleted={this.onStoreyExternalFilesUploadCompleted}
                        onFileUploadCompleted={this.onStoreyExternalFileUploadCompleted}
                        onUpload={() =>
                            this.uploadStoreyFile(
                                this.props.planOrder.stories[this.state.selectedExternalStoreyIndex]
                                    .id,
                                'external'
                            )
                        }
                        closeModal={() =>
                            this.setState({
                                showStoreyExternalFilesModal: false
                            } as IState)
                        }
                    />
                )}
                {this.state.showConnectCubiCasaModal && (
                    <ConnectCubiCasaModal
                        onSave={(cubiCasaOrderId: string) => {
                            this.connectCubiCasaOrder(cubiCasaOrderId);
                        }}
                        closeModal={(this.closeConnectCubiCasatModal)} 
                        cubiCasaOrderId={this.props.planOrder.cubiCasaOrderId}
                    />
                )}
                {this.state.showDeleteStoreyConfirmation && (
                    <ConfirmationModal
                        title={Translate('order/plan/delete-storey/confirmation/title')}
                        text={Translate('order/plan/delete-storey/confirmation/text')}
                        doButtonLabel={Translate('order/plan/delete-storey/confirmation/do-button')}
                        cancelButtonLabel={Translate(
                            'order/plan/delete-storey/confirmation/cancel-button'
                        )}
                        doButtonStyle="danger"
                        do={this.state.confirmationDoAction}
                        closeModal={() =>
                            this.setState({
                                showDeleteStoreyConfirmation: false,
                                confirmationDoAction: null
                            } as IState)
                        }
                    />
                )}
                {this.state.showResetDeliveryConfirmationModal && (
                    <ConfirmationModal
                        title={Translate('order/plan/reset-delivery/confirmation/title')}
                        text={Translate('order/plan/reset-delivery/confirmation/text')}
                        doButtonLabel={Translate(
                            'order/plan/reset-delivery/confirmation/do-button'
                        )}
                        cancelButtonLabel={Translate(
                            'order/plan/reset-delivery/confirmation/cancel-button'
                        )}
                        doButtonStyle="danger"
                        do={() => this.resetDelivery()}
                        closeModal={() =>
                            this.setState({
                                showResetDeliveryConfirmationModal: false
                            } as IState)
                        }
                    />
                )}
                {this.state.showStopDeliveryConfirmationModal && (
                    <ConfirmationModal
                        title={Translate('order/plan/stop-delivery/confirmation/title')}
                        text={Translate('order/plan/stop-delivery/confirmation/text')}
                        doButtonLabel={Translate('order/plan/stop-delivery/confirmation/do-button')}
                        cancelButtonLabel={Translate(
                            'order/plan/stop-delivery/confirmation/cancel-button'
                        )}
                        doButtonStyle="danger"
                        do={() => this.stopDelivery()}
                        closeModal={() =>
                            this.setState({
                                showStopDeliveryConfirmationModal: false
                            } as IState)
                        }
                    />
                )}
                {this.state.showEditOrderRowModal && (
                    <Modal
                        show={true}
                        onHide={() =>
                            this.setState({
                                showEditOrderRowModal: false
                            } as IState)
                        }
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {Translate(
                                    'view-order/basic-order-info/modal/edit-order-row/title'
                                )}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <OrderRowForm
                                orderType={OrderTypes.photo}
                                errors={this.state.editOrderRowFormErrors}
                                onChange={this.onOrderRowChange}
                                onPhotographerCompensationSetManuallyChange={
                                    this.onPhotographerCompensationSetManuallyChange
                                }
                                orderRow={this.state.orderRow as any}
                                possibleProducts={this.props.order.possibleProductsForUpdate}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.closeEditOrderRowModal()}>
                                {Translate(
                                    'view-order/basic-order-info/modal/edit-order-row/button-labels/cancel'
                                )}
                            </Button>
                            <Button
                                bsStyle="primary"
                                onClick={() => this.toggleEditRowConfirmation()}
                            >
                                {Translate(
                                    'view-order/basic-order-info/modal/edit-order-row/button-labels/do'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {this.state.showEditOrderRowConfirmModal && (
                    <ConfirmationModal
                        closeModal={() => this.toggleEditRowConfirmation()}
                        title={Translate('view-order/basic-order-info/modal/edit-order-row/title')}
                        text={this.getEditOrderRowText()}
                        doButtonLabel={Translate(
                            'view-order/basic-order-info/modal/edit-order-row/button-labels/do'
                        )}
                        cancelButtonLabel={Translate(
                            'view-order/basic-order-info/modal/edit-order-row/button-labels/cancel'
                        )}
                        doButtonStyle="danger"
                        do={() => this.updateOrderRow()}
                        disableSubmit={true}
                        initialSubmitDisabling={false}
                    />
                )}
                {this.state.showConfirmUploadStoreyFileModal && (
                    <ConfirmationModal
                        closeModal={() =>
                            this.setState({
                                showConfirmUploadStoreyFileModal: false,
                                uploadFileStoreyId: null,
                                uploadStoreyFileProperty: null
                            } as IState)
                        }
                        title={Translate(
                            'view-order/admin-planorder/confirm-upload-storey-file-modal/title'
                        )}
                        text={Translate(
                            'view-order/admin-planorder/confirm-upload-storey-file-modal/text'
                        )}
                        doButtonLabel={Translate(
                            'view-order/admin-planorder/confirm-upload-storey-file-modal/buttons/do'
                        )}
                        cancelButtonLabel={Translate(
                            'view-order/admin-planorder/confirm-upload-storey-file-modal/buttons/cancel'
                        )}
                        doButtonStyle="danger"
                        do={() =>
                            this.uploadStoreyFile(
                                this.state.uploadFileStoreyId,
                                this.state.uploadStoreyFileProperty
                            )
                        }
                        disableSubmit={true}
                        initialSubmitDisabling={false}
                    />
                )}
            </div>
        );
    }

    canReturnToCubiCasa(): boolean {
        return (
            this.props.planOrder.cubiCasaOrderStatus.value == CubiCasaOrderStatus.READY &&
            ((this.props.planOrder.sketchUpStatus.id == Status.notOrdered &&
                this.props.planOrder.roomSketcherStatus.id < Status.working) ||
                (this.props.planOrder.roomSketcherStatus.id == Status.notOrdered &&
                    this.props.planOrder.sketchUpStatus.id < Status.working))
        );
    }

    canDeleteCubiCasaOrder(): boolean {
        return (
            this.props.planOrder.cubiCasaOrderId !== '' &&
            this.props.planOrder.cubiCasaOrderStatus.value === CubiCasaOrderStatus.CREATED
        );
    }

    returnCubiCasaOrder(): void {
        this.setState({ loading: true } as IState);
        this.props.actions
            .returnCubiCasaOrder(this.props.planOrder.id)
            .then(() => {
                this.setState({ loading: false } as IState);
                notify.success(
                    Translate('view-order/admin-planorder/returned-cubi-casa-order-success')
                );
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, loading: false } as IState);
                    notify.failure(
                        Translate('view-order/admin-planorder/returned-cubi-casa-order-error')
                    );
                })
            );
    }

    deleteCubiCasaOrder(): void {
        this.setState({ loading: true } as IState);
        this.props.actions
            .deleteCubiCasaOrder(this.props.planOrder.id)
            .then(() => {
                this.setState({ loading: false } as IState);
                this.loadData(this.props.orderId);
                notify.success(
                    Translate('view-order/admin-planorder/deleted-cubi-casa-order-success')
                );
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, loading: false } as IState);
                    notify.failure(
                        Translate('view-order/admin-planorder/deleted-cubi-casa-order-error')
                    );
                })
            );
    }
    
    connectCubiCasaOrder(cubiCasaOrderId:string):void{
       
        this.setState({loading:true } as IState);
        this.props.actions
            .connectCubiCasaOrder(this.props.planOrder.id, cubiCasaOrderId)
            .then(() => {
                this.setState({ loading:false } as IState);
                this.loadData(this.props.orderId);
                notify.success(Translate('view-order/admin-planorder/connected-cubi-casa-order-success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, loading: false } as IState);
                    notify.failure(
                        Translate('view-order/admin-planorder/connected-cubi-casa-order-error')
                    );
                })
            );
    }
    manualSyncCubiCasaOrder = (): void => {
        this.setState({ loading: true } as IState);
        this.props.actions
            .manualSyncCubiCasaOrder(this.props.planOrder.id,this.props.planOrder.cubiCasaOrderId)
            .then(() => {
                this.setState({ loading: false } as IState);
                this.loadData(this.props.orderId);
                notify.success(Translate('view-order/admin-planorder/sync-cubi-casa-order-success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, loading: false } as IState);
                    notify.failure(
                        Translate('view-order/admin-planorder/sync-cubi-casa-order-error')
                    );
                })
            );
    }

    isApproved(): boolean {
        let result =
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.approved ||
            this.props.planOrder.roomSketcherStatus.id === PlanOrderStatus.approved;
        return result;
    }

    confirmUploadStoreyFile(storeyId: number, property: string): void {
        this.setState({
            showConfirmUploadStoreyFileModal: true,
            uploadFileStoreyId: storeyId,
            uploadStoreyFileProperty: property
        } as IState);
    }

    onShowStoreyFileUploadModal(storeyId: number, property: string): void {
        if (this.isApproved()) {
            this.confirmUploadStoreyFile(storeyId, property);
        } else {
            this.uploadStoreyFile(storeyId, property);
        }
    }

    canApprove(): boolean {
        if (!this.props.planOrder.sketchUpStatus || !this.props.planOrder.roomSketcherStatus) {
            return false;
        }

        return (
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.ready ||
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.returned ||
            this.props.planOrder.roomSketcherStatus.id === PlanOrderStatus.ready ||
            this.props.planOrder.roomSketcherStatus.id === PlanOrderStatus.returned
        );
    }

    canGenerate(): boolean {
        if (!this.props.planOrder.isTemplateGenerationActive) {
            return false;
        }

        return (
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.ready ||
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.approved ||
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.delivered ||
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.deliveryError ||
            this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.returned
        );
    }

    updatePlanFirm(e: any) {
        this.props.actions
            .updatePlanFirm(this.props.planOrder.id, e.target.value)
            .then(() => {
                notify.success(Translate('view-order/admin-planorder/change-plan-firm-success'));

                if (this.props.planOrder.planEditorId) {
                    let selectedPlanEditor = this.filterPlanEditorsByPlanFirm().find(
                        (x) => x.id.toString() === this.props.planOrder.planEditorId.toString()
                    );
                    if (!selectedPlanEditor) {
                        this.updatePlanEditor();
                    }
                }
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors } as IState);
                    notify.failure(Translate('view-order/admin-planorder/change-plan-firm-error'));
                })
            );
    }

    filterPlanEditorsByPlanFirm(): ISelectPlanEditor[] {
        return this.props.planEditors.filter(
            (x) =>
                !this.props.planOrder.planFirmId ||
                this.props.planOrder.planFirmId === -1 ||
                x.planFirmId.toString() === this.props.planOrder.planFirmId.toString()
        );
    }

    updatePlanEditor(planEditorId?: number) {
        this.props.actions
            .updatePlanEditor(this.props.planOrder.id, planEditorId)
            .then(() => {
                notify.success(Translate('view-order/admin-planorder/change-plan-editor-success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors } as IState);
                    notify.failure(Translate('view-order/admin-planorder/change-plan-editor-error'));
                })
            );
    }

    removeOrderRow(orderRowId: number) {
        this.props.actions.removeOrderRow(this.props.planOrder.id, orderRowId);
    }

    addOrderRow(productId: number) {
        return this.props.actions.addOrderRow(this.props.planOrder.id, productId);
    }

    openEditOrderRow(orderRowId: number) {
        this.props.actions
            .editOrderRow(this.props.orderId, orderRowId)
            .then(() => this.openEditOrderRowModal(orderRowId))
            .catch((error: any) => handleError(error));
    }

    openEditOrderRowModal(rowId: number): void {
        let orderRow = this.props.order.orderRows.filter((r) => r.id === rowId)[0];
        this.setState({
            editOrderRowFormErrors: {},
            orderRow: assign({}, orderRow),
            showEditOrderRowModal: true
        } as IState);
    }
    closeEditOrderRowModal() {
        this.setState({ showEditOrderRowModal: false } as IState);
    }
    showConnectCubiCasaModal(): void {
        this.setState({ showConnectCubiCasaModal: true } as IState);
    }
    closeConnectCubiCasatModal(){
        this.setState({ showConnectCubiCasaModal: false } as IState);
    }
    toggleEditRowConfirmation() {
        let newStatus = !this.state.showEditOrderRowConfirmModal;

        if (newStatus === true) {
            BasicOrderInfoApi.getOrderRowEditStatus(
                this.props.orderId,
                this.state.orderRow.id,
                this.state.orderRow.productId
            ).then((response) => {
                this.setState({
                    showEditOrderRowConfirmModal: newStatus,
                    includeEditOrderRowFileRemovalWarning:
                        response.operationWillCauseFilesToBeRemoved
                } as IState);
            });
        } else {
            this.setState({
                showEditOrderRowConfirmModal: newStatus,
                includeEditOrderRowFileRemovalWarning: false
            } as IState);
        }
    }

    getEditOrderRowText() {
        if (this.state.includeEditOrderRowFileRemovalWarning) {
            return (
                <p>
                    <i className="material-icons">warning</i>{' '}
                    {Translate('view-order/basic-order-info/products/edit-confirmation-with-files')}
                </p>
            );
        }
        return (
            <p>
                <span>{Translate('view-order/basic-order-info/products/edit-confirmation')}</span>
            </p>
        );
    }

    updateOrderRow(): void {
        this.props.actions
            .updateOrderRow(this.props.orderId, this.state.orderRow as any)
            .then((result) => {
                let orderRow = {
                    id: -1,
                    productId: -1,
                    productName: '',
                    productPriceBrokerFirm: -1,
                    productPricePropertyOwner: -1,
                    photographerCompensation: null,
                    photographerCompensationSetManually: false,
                    quantity: -1,
                    invoiceComment: '',
                    photographerComment: '',
                    productTypeId: -1,
                    manuallySetCompensationBackup: -1,
                    photoOrPlan: PhotoOrPlan.None,
                    invoiceStatus: { value: 0, displayName: '' },
                    canChange: false,
                    canRemove: false
                } as any;

                this.setState({
                    orderRow,
                    showEditOrderRowModal: false,
                    editOrderRowFormErrors: {},
                    showConnectCubiCasaModal: false
                } as IState);

                if (result.canPhotographerHandleProduct === false) {
                    notify.warning(
                        Translate(
                            'view-order/basic-order-info/products/notifications/photographer-cant-handle-product'
                        )
                    );
                }

                notify.success(
                    Translate('view-order/basic-order-info/products/notifications/updated')
                );
                this.props.actions.getPlan(this.props.planOrder.id);
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ editOrderRowFormErrors: errors } as IState);
                })
            );
    }

    onOrderRowChange(e: any): void {
        if (e.target.name === 'product') {
            let value = e.target.value === '' ? -1 : Number(e.target.value);
            this.orderRowProductSelected(value);
            return;
        }

        let orderRow = assign({}, this.state.orderRow);
        if (e.target.type === 'checkbox') {
            orderRow[e.target.name] = e.target.checked;
        } else {
            orderRow[e.target.name] = e.target.value;
        }

        this.setState({ orderRow } as IState);
    }

    orderRowProductSelected(productId: number): void {
        let product = this.props.order.possibleProductsForUpdate.filter(
            (p) => p.id === productId
        )[0];
        let orderRow = assign({}, this.state.orderRow);

        if (!orderRow) {
            orderRow = {} as BasicOrderRow;
        }

        orderRow.productName = product.name;
        orderRow.productPriceBrokerFirm = product.priceBrokerFirm;
        orderRow.productId = product.id;
        orderRow.photographerCompensation = orderRow.photographerCompensationSetManually
            ? orderRow.photographerCompensation
            : product.photographerCompensation;
        orderRow.productPricePropertyOwner = product.pricePropertyOwner;
        this.setState({ orderRow } as IState);
    }

    onPhotographerCompensationSetManuallyChange(e: any): void {
        this.onOrderRowChange(e);
        let orderRow = assign({}, this.state.orderRow);
        if (!orderRow.photographerCompensationSetManually) {
            orderRow.manuallySetCompensationBackup = orderRow.photographerCompensation;
            let product = this.props.order.possibleProductsForUpdate.filter(
                (x: any) => x.id === this.state.orderRow.productId
            )[0];
            orderRow.photographerCompensation = product.photographerCompensation;
        } else {
            if (orderRow.manuallySetCompensationBackup) {
                orderRow.photographerCompensation = orderRow.manuallySetCompensationBackup;
            }
        }
        this.setState({ orderRow } as IState);
    }

    onChangeStorey(item: any, storeyIndex: number) {
        let value = item != null ? item.value : 0;

        if (value === undefined || value === null) {
            return;
        }

        let label = null;

        if (value === -1 || (item && typeof item.value === String.name.toLocaleLowerCase())) {
            value = -1;
            label = item.label;
        }

        this.updateStorey(this.props.planOrder.stories[storeyIndex].id, value, storeyIndex, label);
    }

    updateStorey(
        planOrderStoreyId: number,
        storeyId: number,
        storeyIndex: number,
        customLabel?: string
    ) {
        this.props.actions
            .updateStorey(this.props.planOrder.id, planOrderStoreyId, {
                storeyId: storeyId,
                customStoreyName: customLabel
            })
            .then(() => {
                let errors = assign({}, this.state.errors);
                delete errors[`stories[${storeyIndex}]`];
                this.setState({ errors: errors } as IState);
            })
            .catch(() => {
                notify.failure(Translate('order/plan/error/storey'));
            });
    }

    updateSort(id: number, direction: 'up' | 'down') {
        this.props.actions
            .updateSort(this.props.planOrder.id, {
                id: id,
                direction: direction
            })
            .catch(() => {
                notify.failure(Translate('order/plan/error/sort'));
            });
    }

    showExternalFileAnnotationModal(fileId: number) {
        if (this.state.selectedAnnotationType === DeliveryAnnotation) {
            this.props.actions.editDeliveryFileAnnotation(fileId).then(() => {
                this.setState({
                    showAnnotationModal: true,
                    fontSizeRatioForTextEdit: null
                } as IState);
            });
        } else {
            this.props.actions.editExternalFileAnnotation(fileId).then(() => {
                this.setState({
                    showAnnotationModal: true,
                    fontSizeRatioForTextEdit: null
                } as IState);
            });
        }
    }

    showAnnotationModal(id: number, PlanAnnotationType: string) {
        this.props.actions.editAnnotation(id, PlanAnnotationType).then((result) => {
            this.setState(
                {
                    showAnnotationModal: true,
                    fontSizeRatioForTextEdit: null
                } as IState,
                () => {
                    if (result.enforceFilePlacement) {
                        this.showFilePlacementsModal(id);
                    }
                }
            );
        });
    }

    showFilePlacementsModal(planOrderStoreyFileId: number) {
        this.setState({
            showFilePlacementsModal: true,
            placementModalPlanOrderStoreyFileId: planOrderStoreyFileId
        } as IState);
    }

    saveAnnotation(
        fileId: number,
        data: any,
        revisionType: number,
        annotationType: string,
        hasDoneCrop?: boolean
    ) {
        if (annotationType === AnnotationFloorCrop) {
            return this.props.actions
                .createStorey(this.props.planOrder.id, data.upload)
                .then((result) => {
                    let id = result.stories[result.stories.length - 1].file.id;
                    if (data.canvasContent) {
                        data.upload = data.revisionUpload;
                        delete data.revisionUpload;
                        return this.props.actions.saveAnnotation(
                            id,
                            data,
                            false,
                            revisionType,
                            annotationType
                        );
                    }

                    return result;
                });
        } else {
            return this.props.actions.saveAnnotation(
                fileId,
                data,
                hasDoneCrop,
                revisionType,
                annotationType
            );
        }
    }

    annotateExternalFile(fileId: number): void {
        this.setState({ selectedAnnotationType: ExternalAnnotation } as IState);
        this.showExternalFileAnnotationModal(fileId);
    }

    annotateExternalDeliveryFile(fileId: number): void {
        this.setState({
            selectedAnnotationType: ExternalDeliveryAnnotation
        } as IState);
        this.showExternalFileAnnotationModal(fileId);
    }

    annotateDeliveryFile(fileId: number): void {
        this.setState({ selectedAnnotationType: DeliveryAnnotation } as IState, () => {
            this.showExternalFileAnnotationModal(fileId);
        });
    }

    annotateStorey(fileId: number) {
        this.setState({ selectedAnnotationType: AnnotationNormal } as IState);
        this.showAnnotationModal(fileId, AnnotationNormal);
    }

    annotateTexts(fileId: number) {
        this.setState({ selectedAnnotationType: AnnotationTexts } as IState);
        this.showAnnotationModal(fileId, AnnotationTexts);
    }

    deleteStorey(storeyId: number) {
        this.setState({
            showDeleteStoreyConfirmation: true,
            confirmationDoAction: () => {
                this.props.actions.deleteStorey(this.props.planOrder.id, storeyId).catch(() => {
                    notify.failure(Translate('order/plan/error/delete'));
                });
            }
        } as IState);
    }

    sendForCustomer() {
        this.setState({ isSending: true } as IState);
        this.props.actions
            .sendPlanOrder(this.props.planOrder.id, {
                extraInformation: null,
                stories: this.props.planOrder.stories,
                isExpressDelivery: this.props.planOrder.isExpressDelivery
            } as ISendPlanOrderModel)
            .then(() => {
                notify.success(Translate('order/plan/send-success'));
                this.setState({ isSending: false } as IState);
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({
                        errors: errors,
                        isSending: false
                    } as IState);
                })
            );
    }

    returnToBroker() {
        this.setState({ isSending: true } as IState);
        this.props.actions
            .returnToBroker(this.props.planOrder.id)
            .then(() => {
                this.setState({ isSending: false, errors: {} } as IState);
                notify.success(Translate('view-order/admin-planorder/return/broker-success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({
                        errors: errors,
                        isSending: false
                    } as IState);
                    notify.failure(Translate('view-order/admin-planorder/return/broker-failure'));
                })
            );
    }

    sendToPlanFirm() {
        this.setState({ isSending: true } as IState);
        let stories = this.props.planOrder.stories.map((x) => {
            return { id: x.id, storeyId: x.storeyId };
        });
        this.props.actions
            .sendToPlanFirm(this.props.planOrder.id, { stories: stories })
            .then(() => {
                this.setState({ isSending: false, errors: {} } as IState);
                notify.success(Translate('view-order/admin-planorder/send-to-plan-firm-success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({
                        errors: errors,
                        isSending: false
                    } as IState);
                    notify.failure(Translate('view-order/admin-planorder/send-to-plan-firm-error'));
                })
            );
    }

    setSketchupStatusTo(status: number) {
        this.props.actions
            .setSketchupStatus(this.props.planOrder.id, status)
            .then(() => {
                notify.success(
                    Translate('view-order/admin-planorder/sketchup-status-was-updated-successfully')
                );
            })
            .catch(handleError);
    }

    setRoomsketcherStatusTo(status: number) {
        this.props.actions
            .setRoomsketcherStatus(this.props.planOrder.id, status)
            .then(() => {
                notify.success(
                    Translate(
                        'view-order/admin-planorder/roomsketcher-status-was-updated-successfully'
                    )
                );
            })
            .catch(handleError);
    }

    onUploadCompleted() {
        this.setState({ upload: false } as IState);
    }

    uploadFiles() {
        this.setState({ upload: true } as IState);
    }

    onFileUploadCompleted(response: any) {
        response = response.xhr.response;

        if (response) {
            response = JSON.parse(response);
            this.props.actions.addStorey(response);
        }
    }

    deliver() {
        this.props.actions
            .deliverPlanOrder(this.props.planOrder.id, this.state.delivery)
            .then(() => {
                notify.success(Translate('view-order/admin-planorder/deliver-success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors } as IState);
                })
            );
    }

    return() {
        this.props.actions
            .returnPlanOrder(this.props.planOrder.id)
            .then(() => {
                notify.success(Translate('view-order/admin-planorder/return/success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    if (error.message) {
                        notify.failure(Translate(error.message));
                    }
                })
            );
    }

    returnSketchUp() {
        this.props.actions
            .returnSketchUpPlanOrder(this.props.planOrder.id)
            .then(() => {
                notify.success(Translate('view-order/admin-planorder/return/sketchup-success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    if (error.message) {
                        notify.failure(Translate(error.message));
                    }
                })
            );
    }

    returnRoomSketcher() {
        this.props.actions
            .returnRoomSketcherPlanOrder(this.props.planOrder.id)
            .then(() => {
                notify.success(Translate('view-order/admin-planorder/return/roomsketcher-success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    notify.failure(Translate(error.message));
                })
            );
    }

    downloadFiles() {
        this.props.actions.downloadFiles(this.props.planOrder.id);
    }

    canChangeStartDate() {
        if (!this.props.planOrder.sketchUpStatus || !this.props.planOrder.roomSketcherStatus) {
            return false;
        }

        let sketchUpStatus = this.props.planOrder.sketchUpStatus.id;
        let roomSketcherStatus = this.props.planOrder.roomSketcherStatus.id;

        return (
            (sketchUpStatus === Status.notOrdered || sketchUpStatus === Status.ready) &&
            (roomSketcherStatus === Status.notOrdered || roomSketcherStatus === Status.ready)
        );
    }

    canDeliver() {
        if (!this.props.planOrder.sketchUpStatus || !this.props.planOrder.roomSketcherStatus) {
            return false;
        }

        let sketchUpStatus = this.props.planOrder.sketchUpStatus.id;
        let roomSketcherStatus = this.props.planOrder.roomSketcherStatus.id;

        return (
            (sketchUpStatus === Status.notOrdered || sketchUpStatus === Status.approved) &&
            (roomSketcherStatus === Status.notOrdered || roomSketcherStatus === Status.approved)
        );
    }

    is(planOrderStatus: number): boolean {
        if (planOrderStatus) {
            if (planOrderStatus === Status.notOrdered) {
                return false;
            }

            return true;
        }

        return false;
    }

    canReturnToPlanProvider(statusId: number): boolean {
        if (statusId === Status.returned) {
            return true;
        }

        return false;
    }

    canReturnOrder(): boolean {
        if (!this.props.planOrder.sketchUpStatus || !this.props.planOrder.roomSketcherStatus) {
            return false;
        }

        let fasadId = 4;
        let sketchUpStatus = this.props.planOrder.sketchUpStatus.id;
        let roomSketcherStatus = this.props.planOrder.roomSketcherStatus.id;

        if (
            sketchUpStatus === Status.delivered ||
            sketchUpStatus === Status.deliveryError ||
            roomSketcherStatus === Status.delivered ||
            roomSketcherStatus === Status.deliveryError
        ) {
            return true;
        }

        if (
            this.props.planOrder.contentProvider &&
            this.props.planOrder.contentProvider.value === fasadId &&
            (sketchUpStatus === Status.deliveryInProgress ||
                roomSketcherStatus === Status.deliveryInProgress)
        ) {
            return true;
        }

        return false;
    }

    canSendPlanOrder() {
        if (!this.props.planOrder.sketchUpStatus || !this.props.planOrder.roomSketcherStatus) {
            return false;
        }

        let sketchUpStatus = this.props.planOrder.sketchUpStatus.id;
        let roomSketcherStatus = this.props.planOrder.roomSketcherStatus.id;

        return sketchUpStatus === Status.created || roomSketcherStatus === Status.created;
    }

    canReturnToPlan(status: IStatusModel): boolean {
        if (status) {
            if (status.id === Status.returned || status.id === Status.approved) {
                return true;
            }
        }

        return false;
    }

    canSendToPlanOrReturnToBroker() {
        if (!this.props.planOrder.sketchUpStatus || !this.props.planOrder.roomSketcherStatus) {
            return false;
        }

        let sketchUpStatus = this.props.planOrder.sketchUpStatus.id;
        let roomSketcherStatus = this.props.planOrder.roomSketcherStatus.id;

        return sketchUpStatus === Status.ready || roomSketcherStatus === Status.ready;
    }

    sketchupStatusIsAny(statuses: number[]) {
        return statuses && statuses.some(this.sketchupStatusIs);
    }

    sketchupStatusIs(status: number) {
        if (!this.props.planOrder.sketchUpStatus) {
            return false;
        }

        return this.props.planOrder.sketchUpStatus.id === status;
    }

    roomsketcherStatusIsAny(statuses: number[]) {
        return statuses && statuses.some(this.roomsketcherStatusIs);
    }

    roomsketcherStatusIs(status: number) {
        if (!this.props.planOrder.roomSketcherStatus) {
            return false;
        }

        return this.props.planOrder.roomSketcherStatus.id === status;
    }

    savePlacements(files: any[], planOrderStoreyFileId: number) {
        return this.props.actions
            .updatePlacements(this.props.planOrder.id, files, planOrderStoreyFileId)
            .then((result) => {
                notify.success(Translate('view-order/admin-planorder/update-placements-success'));
                this.setState({
                    showFilePlacementsModal: false,
                    fontSizeRatioForTextEdit: result.fontSizeRatio
                } as IState);
            })
            .catch(() => {
                notify.failure(Translate('view-order/admin-planorder/update-placements-failed'));
            });
    }

    approvePlanOrder() {
        this.props.actions.approvePlanOrder(this.props.planOrder.id).then(() => {
            notify.success(Translate('view-order/admin-planorder/approve-plan-order-success'));
        });
    }

    generateFiles() {
        this.setState({ isGenerating: true } as IState);
        this.props.actions
            .generateFiles(this.props.planOrder.id)
            .then((result: any) => {
                if (result) {
                    notify.success(Translate('view-order/admin-planorder/generate-files-success'));
                } else {
                    notify.warning(
                        Translate('view-order/admin-planorder/generate-files-nothing-new')
                    );
                }

                this.setState({ isGenerating: false } as IState);
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    if (!error) {
                        notify.failure(Translate('view-order/admin-planorder/generate-files-failed'));
                    }

                    this.setState({ isGenerating: false } as IState);
                })
            );
    }

    uploadStoreyFile(storeyId: number, property: string): void {
        let storiesUploads = assign({}, this.state.storiesUploads);

        if (!storiesUploads[storeyId]) {
            storiesUploads[storeyId] = {};
        }

        storiesUploads[storeyId][property] = true;

        this.setState({
            storiesUploads: storiesUploads,
            showConfirmUploadStoreyFileModal: false,
            uploadFileStoreyId: null,
            uploadStoreyFileProperty: null
        } as IState);
    }

    onStoreyFilesUploadCompleted(storeyId: number, ...property: string[]) {
        let storiesUploads = assign({}, this.state.storiesUploads);

        property.forEach((x) => {
            storiesUploads[storeyId][x] = false;
        });

        this.setState({ storiesUploads: storiesUploads } as IState);
    }

    onStoreyFileUploadCompleted(
        response: any,
        planOrderStoreyId: number,
        action: (planOrderStoreyId: number, response: any) => Promise<any>
    ) {
        response = response.xhr.response;

        if (response) {
            response = JSON.parse(response);

            action(planOrderStoreyId, response);
        }
    }

    dataURLtoBlob(dataurl): Blob {
        let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    uploadedPlanOrderInternalExternalFilesChanged(e: any) {
        let selected = assign({}, this.state.selectedPlanOrderInternalExternalFile);
        selected = e.target.value;

        this.setState({
            selectedPlanOrderInternalExternalFile: selected
        } as IState);
    }

    uploadedPlanOrderExternalDeliveryFilesChanged(e: any) {
        let selected = assign({}, this.state.selectedPlanOrderExternalDeliveryFile);
        selected = e.target.value;

        this.setState({
            selectedPlanOrderExternalDeliveryFile: selected
        } as IState);
    }

    uploadPlanOrderExternalFiles() {
        this.setState({ planOrderInternalExternalFilesUpload: true } as IState);
    }

    uploadPlanOrderExternalFilesToCustomer() {
        this.setState({
            planOrderExternalFilesUploadToCustomer: true
        } as IState);
    }

    onPlanOrderExternalFilesUploadCompleted() {
        this.setState({
            planOrderInternalExternalFilesUpload: false,
            planOrderExternalFilesUploadToCustomer: false
        } as IState);
    }

    onPlanOrderInternalExternalFileUploadCompleted(response: any) {
        response = response.xhr.response;

        if (response) {
            let parsedResponse = JSON.parse(response);
            parsedResponse.files.forEach((file) => {
                this.props.actions.addPlanOrderInternalExternalFile(
                    file.id,
                    file.planOrderId,
                    file.fileInfoId,
                    file.filename,
                    file.fileReference,
                    file.fileType,
                    file.thumbnailReference,
                    file.oldFileId
                );
            });
        }
    }

    onPlanOrderExternalDeliveryFileUploadCompleted(response: any) {
        response = response.xhr.response;

        if (response) {
            let parsedResponse = JSON.parse(response);
            parsedResponse.files.forEach((file) => {
                this.props.actions.addPlanOrderExternalDeliveryFile(
                    file.id,
                    file.planOrderId,
                    file.fileInfoId,
                    file.filename,
                    file.fileReference,
                    file.fileType,
                    file.thumbnailReference,
                    file.oldFileId
                );
            });
        }
    }

    deletePlanOrderInternalExternalFile(file: IExternalPlanOrderFile) {
        this.props.actions.deletePlanOrderInternalExternalFile(
            this.props.planOrder.id,
            file.fileInfoId
        );

        this.setState({
            selectedPlanOrderInternalExternalFile: null
        } as IState);
    }

    deletePlanOrderExternalDeliveryFile(file: IExternalPlanOrderFile) {
        this.props.actions.deletePlanOrderExternalDeliveryFile(
            this.props.planOrder.id,
            file.fileInfoId
        );
    }

    openStoreyExternalFileModal(storeyIndex: number) {
        this.setState({
            showStoreyExternalFilesModal: true,
            selectedExternalStoreyIndex: storeyIndex
        } as IState);
    }

    uploadedFilesChanged(e: any) {
        this.setState({ selectedExternalStoreyFile: e.target.value } as IState);
    }

    deletePlanOrderStoreyExternalFile() {
        let file =
            this.props.planOrder.stories[this.state.selectedExternalStoreyIndex].externalFiles[
                this.state.selectedExternalStoreyFile
            ];
        this.props.actions.deletePlanOrderStoreyExternalFile(
            this.props.planOrder.id,
            file.planOrderStoreyId,
            file.fileInfoId
        );
    }

    onStoreyExternalFilesUploadCompleted() {
        let storiesUploads = assign({}, this.state.storiesUploads);
        storiesUploads[
            this.props.planOrder.stories[this.state.selectedExternalStoreyIndex].id
        ].external = false;
        this.setState({ storiesUploads: storiesUploads } as IState);
    }

    onStoreyExternalFileUploadCompleted(response: any) {
        response = response.xhr.response;

        if (response) {
            response = JSON.parse(response);
            this.props.actions.addPlanOrderStoreyExternalFile(
                response.planOrderStoreyId,
                response.fileInfoId,
                response.filename,
                response.fileReference,
                response.fileType,
                response.thumbnailReference,
                response.oldFileInfoId,
                response.oldFileReference
            );
        }
    }

    toggleTemplateGeneration() {
        this.props.actions.toggleTemplateGeneration(this.props.planOrder.id);
    }

    canAnnotatePlacement() {
        return this.props.planOrder.stories && this.props.planOrder.stories.length > 1;
    }

    canResetDelivery() {
        return (
            this.props.planOrder.contentProvider &&
            (this.statusAllowsForReset(this.props.planOrder.sketchUpStatus) ||
                this.statusAllowsForReset(this.props.planOrder.roomSketcherStatus)) &&
            Feature.hasFeature(Feature.ResetContentProviderDelivery, this.props.user) &&
            this.props.planOrder.deliveryDequeueCount >= 0
        );
    }

    canStopDelivery() {
        return (
            this.props.planOrder.deliveryDequeueCount != -1 &&
            (this.props.planOrder.sketchUpStatus.id === Status.deliveryInProgress ||
                this.props.planOrder.roomSketcherStatus.id === Status.deliveryInProgress)
        );
    }

    statusAllowsForReset(status: IStatusModel) {
        return (
            status.id === Status.deliveryInProgress ||
            status.id === Status.deliveryError ||
            status.id === Status.delivered
        );
    }

    resetDelivery() {
        this.props.actions
            .resetDelivery(this.props.orderId)
            .then((result: string) => notify.success(Translate(result)))
            .catch((error: any) => handleError(error));
    }

    stopDelivery() {
        this.props.actions
            .stopDelivery(this.props.orderId)
            .then((result: string) => notify.success(Translate(result)))
            .catch((error: any) => handleError(error));
    }

    grabPlanOrder(): void {
        this.props.actions
            .grabPlanOrder(this.props.planOrder.id)
            .then(() => notify.success(Translate('view-order/admin-planorder/grab-success')));
    }

    createEmptyStorey() {
        this.props.actions.createEmptyStorey(this.props.planOrder.id);
    }

    canGrabPlanOrder(): boolean {
        if (!Feature.hasFeature(Feature.AdminGrabPlanOrder, this.props.user)) {
            return false;
        }

        if (
            this.props.planOrder.sketchUpStatus &&
            (this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.unedited ||
                this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.working)
        ) {
            return true;
        }

        return false;
    }

    isFileLocked(status: number) {
        return status === PlanOrderStatus.unedited || status === PlanOrderStatus.working;
    }

    deleteDeliveryFile(reference: string) {
        this.props.actions
            .deleteDeliveryFile(reference)
            .then(() => {
                this.setState({
                    showImageModal: false,
                    selectedImage: null
                } as IState);
                notify.success(Translate('order/plan/delivery-file/removed-successfully'));
            })
            .catch((error: any) => handleError(error));
    }

    hideDeliveryFailure(sketchUpStatus: number, roomSketcherStatus: number): void {
        this.props.actions
            .hideDeliveryFailure(this.props.planOrder.id, sketchUpStatus, roomSketcherStatus)
            .catch((error: any) => handleError(error));
    }

    isDelivered(): boolean {
        if (
            this.props.planOrder.sketchUpStatus &&
            (this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.delivered ||
                this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.deliveryInProgress ||
                this.props.planOrder.sketchUpStatus.id === PlanOrderStatus.deliveryError)
        ) {
            return true;
        }

        if (
            this.props.planOrder.roomSketcherStatus &&
            (this.props.planOrder.roomSketcherStatus.id === PlanOrderStatus.delivered ||
                this.props.planOrder.roomSketcherStatus.id === PlanOrderStatus.deliveryInProgress ||
                this.props.planOrder.roomSketcherStatus.id === PlanOrderStatus.deliveryError)
        ) {
            return true;
        }

        return false;
    }

    emailFiles() {
        this.props.actions
            .emailFiles(this.props.planOrder.id)
            .then(() => {
                notify.success(Translate('order/plan/admin/email-files-success'));
            })
            .catch(() => {
                notify.failure(Translate('order/plan/admin/email-files-error'));
            });
    }

    email() {
        this.props.actions
            .email(this.props.planOrder.id)
            .then(() => {
                notify.success(Translate('order/plan/admin/email-success'));
            })
            .catch(() => {
                notify.failure(Translate('order/plan/admin/email-error'));
            });
    }

    inActivateExternalFile(externalfileId: number) {
        this.props.actions
            .inActivateExternalFile(externalfileId)
            .then(() =>
                notify.success(
                    Translate('view-order/admin-planorder/external-file-removed-success')
                )
            )
            .catch(handleError);
    }

    resetScheduledDelivery() {
        this.props.actions
            .resetScheduledDelivery(this.props.planOrder.id)
            .then(() =>
                notify.success(Translate('order/plan/admin-planorder/reset-scheduled-success'))
            )
            .catch(() =>
                notify.failure(Translate('order/plan/admin-planorder/reset-scheduled-error'))
            );
    }
}

function mapStateToProps(state: any) {
    return {
        order: state.basicOrderInfo,
        planOrder: state.viewPlanOrder.planOrder,
        products: state.viewPlanOrder.products,
        planUserFirms: state.viewPlanOrder.planUserFirms,
        planEditors: state.viewPlanOrder.planEditors,
        annotation: state.viewPlanOrder.annotation,
        user: state.user,
        compareStoreys: state.viewPlanOrder.compareStoreys,
        archivedInfo: selectArchivedInfo(state)
    };
}

function mapDispatchToProps(dispatch: any): { actions: IActions } {
    return {
        actions: {
            getPlan: (planOrderId: number) => dispatch(actions.getAdminPlanOrder(planOrderId)),
            updatePlanFirm: (planOrderId: number, planFirmId: number) =>
                dispatch(actions.updatePlanFirm(planOrderId, planFirmId)),
            updatePlanEditor: (planOrderId: number, planEditorId: number) =>
                dispatch(actions.updatePlanEditor(planOrderId, planEditorId)),
            removeOrderRow: (planOrderId: number, orderRowId: number) =>
                dispatch(actions.removePlanOrderRow(planOrderId, orderRowId)),
            addOrderRow: (planOrderId: number, productId: number) =>
                dispatch(actions.addOrderRow(planOrderId, productId)),
            updateStorey: (planOrderId: number, planOrderStoreyId: number, data: IUpdateStorey) =>
                dispatch(actions.updatePlanOrder(planOrderId, planOrderStoreyId, data)),
            updateSort: (planOrderId: number, storey: IUpdateSortModel) =>
                dispatch(actions.updatePlanOrderStoreySort(planOrderId, storey)),
            editExternalFileAnnotation: (fileId: number) =>
                dispatch(actions.editExternalFileAnnotation(fileId)),
            editDeliveryFileAnnotation: (fileId: number) =>
                dispatch(actions.editDeliveryFileAnnotation(fileId)),
            editAnnotation: (id: number, planAnnotationType: string) =>
                dispatch(actions.editAnnotation(id, planAnnotationType)),
            saveAnnotation: (
                planOrderStoreyFileId: number,
                data: string,
                hasDoneCrop: boolean,
                revisionType: number,
                annotationType: string
            ) =>
                dispatch(
                    actions.saveAnnotation(
                        planOrderStoreyFileId,
                        data,
                        hasDoneCrop,
                        revisionType,
                        annotationType
                    )
                ),
            deleteStorey: (planOrder: number, storeyId: number) =>
                dispatch(actions.deleteStorey(planOrder, storeyId)),
            sendPlanOrder: (planOrderId: number, planOrder: ISendPlanOrderModel) =>
                dispatch(actions.adminSendPlanOrder(planOrderId, planOrder)),
            sendToPlanFirm: (planOrderId: number, data: any) =>
                dispatch(actions.sendToPlanFirm(planOrderId, data)),
            addStorey: (storey: any) => dispatch(actions.addStorey(storey)),
            deliverPlanOrder: (planOrderId: number, data: IDelivery) =>
                dispatch(actions.deliverPlanOrder(planOrderId, data)),
            returnPlanOrder: (planOrderId: number) =>
                dispatch(actions.returnPlanOrder(planOrderId, null)),
            returnSketchUpPlanOrder: (planOrderId: number) =>
                dispatch(actions.returnSketchUpPlanOrder(planOrderId)),
            returnRoomSketcherPlanOrder: (planOrderId: number) =>
                dispatch(actions.returnRoomSketcherPlanOrder(planOrderId)),
            downloadFiles: (planOrderId: number) => dispatch(actions.downloadFiles(planOrderId)),
            updatePlacements: (planOrderId: number, files: any[], planOrderStoreyFileId: number) =>
                dispatch(actions.updatePlacements(planOrderId, files, planOrderStoreyFileId)),
            generateFiles: (planOrderId: number) => dispatch(actions.generateFiles(planOrderId)),
            approvePlanOrder: (planOrderId: number) =>
                dispatch(actions.approvePlanOrder(planOrderId)),
            addPlanOrderStoreyBlueprintFile: (planOrderStoreyId: number, file: any) =>
                dispatch(actions.addPlanOrderStoreyBlueprintFile(planOrderStoreyId, file)),
            addPlanOrderStoreySketchUp2DFile: (planOrderStoreyId: number, file: any) =>
                dispatch(actions.addPlanOrderStoreySketchUp2DFile(planOrderStoreyId, file)),
            addPlanOrderStoreySketchUp3DFile: (planOrderStoreyId: number, file: any) =>
                dispatch(actions.addPlanOrderStoreySketchUp3DFile(planOrderStoreyId, file)),
            addPlanOrderStoreyRoomSketcher2DFile: (planOrderStoreyId: number, file: any) =>
                dispatch(actions.addPlanOrderStoreyRoomSketcher2DFile(planOrderStoreyId, file)),
            addPlanOrderStoreyRoomSketcher3DFile: (planOrderStoreyId: number, file: any) =>
                dispatch(actions.addPlanOrderStoreyRoomSketcher3DFile(planOrderStoreyId, file)),
            addPlanOrderInternalExternalFile: (
                id: number,
                planOrderId: number,
                fileInfoId: number,
                filename: string,
                fileReference: string,
                fileType: string,
                thumbnailReference: string,
                oldFileId: number
            ) =>
                dispatch(
                    actions.addPlanOrderInternalExternalFile(
                        id,
                        planOrderId,
                        fileInfoId,
                        filename,
                        fileReference,
                        fileType,
                        thumbnailReference,
                        oldFileId
                    )
                ),
            addPlanOrderExternalDeliveryFile: (
                id: number,
                planOrderId: number,
                fileInfoId: number,
                filename: string,
                fileReference: string,
                fileType: string,
                thumbnailReference: string,
                oldFileId: number
            ) =>
                dispatch(
                    actions.addPlanOrderExternalDeliveryFile(
                        id,
                        planOrderId,
                        fileInfoId,
                        filename,
                        fileReference,
                        fileType,
                        thumbnailReference,
                        oldFileId
                    )
                ),
            addPlanOrderStoreyExternalFile: (
                planOrderStoreyId: number,
                fileInfoId: number,
                filename: string,
                fileReference: string,
                fileType: string,
                thumbnailReference: string,
                oldFileInfoId: number,
                oldFileReference: string
            ) =>
                dispatch(
                    actions.addPlanOrderStoreyExternalFile(
                        planOrderStoreyId,
                        fileInfoId,
                        filename,
                        fileReference,
                        fileType,
                        thumbnailReference,
                        oldFileInfoId,
                        oldFileReference
                    )
                ),
            deletePlanOrderInternalExternalFile: (planOrderId: number, fileInfoId: number) =>
                dispatch(actions.deletePlanOrderInternalExternalFile(planOrderId, fileInfoId)),
            deletePlanOrderExternalDeliveryFile: (planOrderId: number, fileInfoId: number) =>
                dispatch(actions.deletePlanOrderExternalDeliveryFile(planOrderId, fileInfoId)),
            deletePlanOrderStoreyExternalFile: (
                planOrderId: number,
                planOrderStoreyId: number,
                fileInfoId: number
            ) =>
                dispatch(
                    actions.deletePlanOrderStoreyExternalFile(
                        planOrderId,
                        planOrderStoreyId,
                        fileInfoId
                    )
                ),
            createStorey: (planOrderId: number, data: any) =>
                dispatch(actions.createStorey(planOrderId, data)),
            updateStartDate: (planOrderId: number, date: any) =>
                dispatch(actions.updateStartDate(planOrderId, date)),
            toggleTemplateGeneration: (planOrderId: number) =>
                dispatch(actions.toggleTemplateGeneration(planOrderId)),
            resetDelivery: (planOrderId: number) => dispatch(actions.resetDelivery(planOrderId)),
            stopDelivery: (planOrderId: number) => dispatch(actions.stopDelivery(planOrderId)),
            grabPlanOrder: (planOrderId: number) => dispatch(actions.adminGrab(planOrderId)),
            createEmptyStorey: (planOrderId: number) =>
                dispatch(actions.createEmptyStorey(planOrderId)),
            deleteDeliveryFile: (reference: string) =>
                dispatch(actions.deleteDeliveryFile(reference)),
            hideDeliveryFailure: (
                planOrderId: number,
                sketchUpStatus: number,
                roomSketcherStatus: number
            ) =>
                dispatch(
                    actions.hideDeliveryFailure(planOrderId, sketchUpStatus, roomSketcherStatus)
                ),
            returnToBroker: (planOrderId: number) => dispatch(actions.returnToBroker(planOrderId)),
            setSketchupStatus: (planorderId: number, newStatus: number) =>
                dispatch(actions.setSketchupStatus(planorderId, newStatus)),
            setRoomsketcherStatus: (planorderId: number, newStatus: number) =>
                dispatch(actions.setRoomsketcherStatus(planorderId, newStatus)),
            editOrderRow: (orderId: number, rowId: number) =>
                dispatch(editOrderRow(orderId, rowId)),
            updateOrderRow: (orderId: number, orderRow: any) =>
                dispatch(updateOrderRow(orderId, orderRow)),
            emailFiles: (planOrderId: number) => dispatch(actions.emailFiles(planOrderId)),
            email: (planOrderId: number) => dispatch(actions.email(planOrderId)),
            inActivateExternalFile: (planOrderExternalFileId: number) =>
                dispatch(actions.inActivateExternalFile(planOrderExternalFileId)),
            resetScheduledDelivery: (planOrderId: number) =>
                dispatch(actions.resetScheduledDelivery(planOrderId)),
            getCompareData: (planOrderId: number) => dispatch(actions.getCompareData(planOrderId)),
            checkIfOrderIsArchived: (planOrderId: number) =>
                dispatch(checkIfOrderIsArchived(planOrderId)),
            resetPlanOrderArchiveState: (planOrderId: number) =>
                dispatch(actions.resetPlanOrderArchiveState(planOrderId)),
            returnCubiCasaOrder: (planOrderId: number) =>
                dispatch(actions.returnCubiCasaOrder(planOrderId)),
            deleteCubiCasaOrder: (planOrderId: number) =>
                dispatch(actions.deleteCubiCasaOrder(planOrderId)),
            connectCubiCasaOrder:(planOrderId: number, cubiCasaOrderId: string) => 
                dispatch(actions.connectCubiCasaOrder(planOrderId, cubiCasaOrderId)),
            manualSyncCubiCasaOrder:(planOrderId:number,cubiCasaOrderId: string) =>
                dispatch(actions.manualSyncCubiCasaOrder(planOrderId,cubiCasaOrderId))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminPlanOrderForm));
